import React from 'react';
import {
  Grid,
  TextField,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Checkbox,
  Radio,
  Select,
  MenuItem,
  Input,
  Chip,
  Switch,
  Dialog,
  DialogContent,
  Icon,
  withStyles,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Tabs,
  Tab,
} from '@material-ui/core';
import InputLabel from '@material-ui/core/InputLabel';
import AppState from '../../state';
import MaskedInput from 'react-text-mask';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { Utils } from '../../services';
import moment from 'moment';
import CurrencyInput from '../../components/lib/CurrencyInput';

import * as funcionarioAPI from '../../api/funcionarios';

import {
  toast,
  Modal,
  PageTitle,
  SectionTitle,
  Button as DsButton,
  Breadcrumb,
  Panel,
  FieldRow,
  Tag,
  toneForVinculo,
} from '../../components/ds';
const BigChip = withStyles({
  deleteIcon: {
    position: 'absolute',
    right: '0',
  },
})(Chip);

// Rótulos das opções de desligamento. Os valores (coluna da esquerda) são os
// únicos aceitos pela restrição CHECK da tabela funcionario_desligamento.
const MOTIVOS_DESLIGAMENTO = [
  { valor: 'sem_justa_causa', rotulo: 'Sem justa causa' },
  { valor: 'justa_causa', rotulo: 'Justa causa' },
  { valor: 'pedido', rotulo: 'Pedido de demissão' },
  { valor: 'acordo', rotulo: 'Acordo entre as partes' },
  { valor: 'termino_experiencia', rotulo: 'Término de contrato de experiência' },
  { valor: 'falecimento', rotulo: 'Falecimento do empregado' },
];

const AVISOS_PREVIOS = [
  { valor: 'trabalhado', rotulo: 'Trabalhado' },
  { valor: 'indenizado', rotulo: 'Indenizado' },
];

const rotuloDe = (lista, valor) => {
  const achado = lista.filter((i) => i.valor === valor)[0];
  return achado ? achado.rotulo : valor || '—';
};

const simNao = (valor) => (valor === true || valor === 't' || valor === 'true' ? 'Sim' : 'Não');

const styles = {
  halfGrid: {
    display: 'flex',
    flexDirection: 'row',
    gap: '16px',
    width: '100%',
    maxWidth: '100%',
    flexBasis: 'auto',
  },
  modalButton: {
    marginTop: 10,
    fontSize: '0.875rem',
    backgroundColor: '#3f51b5',
    color: 'white',
    fontWeight: 'bold',
    border: '1px solid #3f51b5',
    '&:hover': {
      backgroundColor: '#303f9f',
      color: 'white',
    },
  },
  actionCell: {
    width: '50px',
  },
};

const CPFMaskCustom = (props) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      // ref={inputRef}
      mask={[
        /\d/,
        /\d/,
        /\d/,
        '.',
        /\d/,
        /\d/,
        /\d/,
        '.',
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
      ]}
      guide={false}
    />
  );
};

const CPFMaskCustomEdit = (props) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      // ref={inputRef}
      mask={[
        /\d/,
        /\d/,
        /\d/,
        '.',
        /\d/,
        /\d/,
        /\d/,
        '.',
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        '-',
        /\w/,
        /\w/,
        /\w/,
        /\w/,
        /\w/,
      ]}
      guide={false}
    />
  );
};

const CurrencyMaskCustom = (props) => {
  const { inputRef, ...other } = props;

  const numberMask = createNumberMask({
    prefix: 'R$ ',
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol: '.',
    allowDecimal: true,
    decimalSymbol: ',',
    decimalLimit: 2,
    integerLimit: 6,
    allowNegative: false,
  });

  return (
    <MaskedInput
      {...other}
      // ref={inputRef}
      mask={numberMask}
      guide={false}
    />
  );
};

const DateMaskCustom = (props) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      // ref={inputRef}
      mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
      guide={false}
    />
  );
};

const CelMaskCustom = (props) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      // ref={inputRef}
      mask={[
        '(',
        /\d/,
        /\d/,
        ')',
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ]}
      guide={true}
    />
  );
};

const TelMaskCustom = (props) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      // ref={inputRef}
      mask={[
        '(',
        /\d/,
        /\d/,
        ')',
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ]}
      guide={true}
    />
  );
};

const CEPMaskCustom = (props) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      // ref={inputRef}
      mask={[/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]}
      guide={false}
    />
  );
};

const UFMaskCustom = (props) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      // ref={inputRef}
      mask={[/\d/, /\d/]}
      guide={false}
    />
  );
};

const RGMaskCustom = (props) => {
  const { inputRef, ...other } = props;
  return (
    <MaskedInput
      {...other}
      mask={[/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\w/]}
      guide={false}
    />
  );
};

const ElevenDigitsMaskCustom = (props) => {
  const { inputRef, ...other } = props;
  return (
    <MaskedInput
      {...other}
      mask={[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
      guide={false}
    />
  );
};

const NineDigitsMaskCustom = (props) => {
  const { inputRef, ...other } = props;
  return (
    <MaskedInput
      {...other}
      mask={[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
      guide={false}
    />
  );
};

const FourDigitsMaskCustom = (props) => {
  const { inputRef, ...other } = props;
  return (
    <MaskedInput
      {...other}
      mask={[/\d/, /\d/, /\d/, /\d/]}
      guide={false}
    />
  );
};

CPFMaskCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

CPFMaskCustomEdit.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

DateMaskCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

CelMaskCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

TelMaskCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

CEPMaskCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

UFMaskCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

RGMaskCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

ElevenDigitsMaskCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

NineDigitsMaskCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

FourDigitsMaskCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

// Traduz o que o servidor devolve em projetos_autorizados para os três campos
// que o formulário usa: se a pessoa está em um único projeto, ela é tratada
// como exclusiva dele; em mais de um, como não exclusiva.
const alocacaoDoFuncionario = (autorizados) => {
  const lista = (autorizados || []).filter(
    (p) => String(p.id_projeto) !== '0'
  );
  const naoExclusivo = (autorizados || []).some(
    (p) => String(p.id_projeto) === '0'
  );

  if (naoExclusivo || lista.length > 1) {
    return {
      exclusivo: 'false',
      project: '',
      projetos: lista.map((p) => ({
        id_projeto: p.id_projeto,
        desc_curta: p.desc_curta,
      })),
    };
  }

  return {
    exclusivo: lista.length === 1 ? 'true' : '',
    project: lista.length === 1 ? lista[0].id_projeto : '',
    projetos: [],
  };
};

// Card de cada seção da ficha. Fica FORA do render de propósito: definido
// dentro dele, cada tecla digitada criava um componente novo, o React
// remontava a seção inteira e o campo perdia o foco (era o "bug" ao digitar o
// CPF no cadastro novo). Em pageMode vira um card (Panel); no modal, título
// solto como sempre foi.
const SecaoFicha = ({ pageMode, title, actions, children, style }) =>
  pageMode ? (
    <Panel title={title} actions={actions} style={style}>{children}</Panel>
  ) : (
    <div style={style}>
      <SectionTitle style={{ marginBottom: '16px' }}>{title}</SectionTitle>
      {children}
    </div>
  );

const OPCOES_ESCOLARIDADE = [
  'Fundamental completo',
  'Médio incompleto',
  'Médio completo',
  'Superior incompleto',
  'Superior completo',
  'Pós-graduação completa',
  'Mestrado completo',
  'Doutorado completo',
];
const OPCOES_RACA_COR = ['Branca', 'Preta', 'Parda', 'Amarela', 'Indígena', 'Não informado'];

// Cadastro antigo pode ter um valor digitado à mão que não está na lista: ele
// continua aparecendo como opção, para não sumir da ficha nem ser apagado ao
// salvar sem querer.
const opcoesComAtual = (opcoes, atual) =>
  atual && !opcoes.includes(atual) ? [...opcoes, atual] : opcoes;

// Tipos de deficiência (eSocial), para o select. O detalhe vai no texto livre.
const TIPOS_PCD = [
  ['fisica', 'Física'],
  ['auditiva', 'Auditiva'],
  ['visual', 'Visual'],
  ['intelectual', 'Intelectual'],
  ['mental', 'Mental'],
  ['multipla', 'Múltipla'],
  ['reabilitado', 'Reabilitado (INSS)'],
];
const rotuloTipoPcd = (tipo) => {
  const achado = TIPOS_PCD.find(([t]) => t === tipo);
  return achado ? achado[1] : tipo || '';
};

// Benefícios do contrato: [campo no state, coluna no banco, rótulo].
const BENEFICIOS_CADASTRO = [
  ['temValeTransporte', 'tem_vale_transporte', 'Vale-transporte'],
  ['temValeAlimentacao', 'tem_vale_alimentacao', 'Vale-alimentação'],
  ['temPlanoSaude', 'tem_plano_saude', 'Plano de saúde'],
  ['temSeguroVida', 'tem_seguro_vida', 'Seguro de vida'],
  ['temAuxilioCreche', 'tem_auxilio_creche', 'Auxílio-creche'],
];

const ehVerdadeiro = (v) => v === true || v === 't' || v === 'true';

// Vale-transporte: cada linha é uma passagem do dia (operadora, valor e
// quantas vezes por dia). Ex.: Rio Card 7,90 x 2 + Jaé 5,00 x 2.
const OPERADORAS_VT = [
  ['riocard', 'Rio Card'],
  ['jae', 'Jaé'],
];
const novaTarifaVt = () => ({ operadora: 'riocard', valor: '', viagens: '2' });
const numeroBR = (v) => {
  const t = String(v === null || v === undefined ? '' : v).trim();
  // "1.234,56" ou "7,90" (pt-BR); "7.90" vindo do banco também vale.
  return parseFloat(t.indexOf(',') >= 0 ? t.replace(/\./g, '').replace(',', '.') : t);
};
const formatarBR = (n) => Number(n).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
// Vale-alimentação/refeição: um cartão por pessoa. Alelo e VR são A
// (alimentação) ou R (refeição); iFood vale para os dois.
const OPERADORAS_VA = [
  ['alelo', 'Alelo'],
  ['vr', 'VR'],
  ['ifood', 'iFood'],
];
const TIPOS_VA = [
  ['A', 'A - Alimentação'],
  ['R', 'R - Refeição'],
];
const vaPedeTipo = (op) => op === 'alelo' || op === 'vr';
const erroValeAlimentacao = (estado) => {
  if (!estado.temValeAlimentacao || !estado.vaOperadora) return '';
  if (vaPedeTipo(estado.vaOperadora) && !estado.vaTipo) return 'Vale-alimentação: escolha A (alimentação) ou R (refeição).';
  const v = numeroBR(estado.vaValorDia);
  if (!(v > 0 && v < 1000)) return 'Vale-alimentação: informe o valor por dia.';
  return '';
};
const textoValeAlimentacao = (estado) => {
  if (!estado.vaOperadora) return 'Cartão não informado';
  const op = (OPERADORAS_VA.find(([o]) => o === estado.vaOperadora) || [null, estado.vaOperadora])[1];
  const tipo = vaPedeTipo(estado.vaOperadora)
    ? (estado.vaTipo === 'R' ? 'Refeição' : estado.vaTipo === 'A' ? 'Alimentação' : 'tipo não informado')
    : 'Alimentação e refeição';
  const valor = numeroBR(estado.vaValorDia);
  return `${op} · ${tipo}${valor > 0 ? ` · R$ ${formatarBR(valor)} por dia` : ''}`;
};
const tarifaVazia = (t) => !String(t.valor || '').trim();
// Mensagem do primeiro erro nas tarifas, ou '' quando estão certas.
const erroTarifasVt = (tarifas) => {
  for (let i = 0; i < tarifas.length; i++) {
    const t = tarifas[i];
    if (tarifaVazia(t)) continue;
    const valor = numeroBR(t.valor);
    const viagens = Number(t.viagens);
    if (!(valor > 0 && valor < 1000)) return `Vale-transporte, linha ${i + 1}: valor da passagem inválido.`;
    if (!Number.isInteger(viagens) || viagens < 1 || viagens > 20) return `Vale-transporte, linha ${i + 1}: vezes por dia de 1 a 20.`;
  }
  return '';
};
const textoTarifasVt = (tarifas) => {
  const validas = tarifas.filter((t) => !tarifaVazia(t) && numeroBR(t.valor) > 0);
  if (!validas.length) return 'Sem passagens cadastradas';
  const custoDia = validas.reduce((s, t) => s + numeroBR(t.valor) * Number(t.viagens || 0), 0);
  return OPERADORAS_VT.map(([op, rotulo]) => {
    const linhas = validas.filter((t) => t.operadora === op);
    if (!linhas.length) return null;
    return `${rotulo}: ${linhas.map((t) => `${formatarBR(numeroBR(t.valor))} x ${t.viagens}`).join(' + ')}`;
  }).filter(Boolean).join(' · ') + ` (R$ ${formatarBR(custoDia)} por dia)`;
};

// Lê do registro do banco os campos de deficiência e benefícios.
const lerCamposExtras = (registro) => {
  const campos = {
    pcd: ehVerdadeiro(registro.pcd),
    pcdTipo: registro.pcd_tipo || '',
    pcdDescricao: registro.pcd_descricao || '',
    tituloEleitor: registro.titulo_eleitor || '',
    tituloZona: registro.titulo_zona || '',
    tituloSessao: registro.titulo_sessao || '',
    dtExameAdmissional: registro.dt_exame_admissional ? Utils.dateToPT(registro.dt_exame_admissional) : '',
    vaOperadora: registro.va_operadora || '',
    vaTipo: (registro.va_tipo || '').trim(),
    vaValorDia: registro.va_valor_dia ? formatarBR(registro.va_valor_dia) : '',
    tarifasVt: (registro.tarifas_vt || []).map((t) => ({
      operadora: t.operadora,
      valor: formatarBR(t.valor),
      viagens: String(t.viagens_dia),
    })),
  };
  BENEFICIOS_CADASTRO.forEach(([estado, coluna]) => {
    campos[estado] = ehVerdadeiro(registro[coluna]);
  });
  return campos;
};

class Form extends React.Component {
  constructor(props) {
    super(props);

    this.documentoInput = React.createRef();

    this.state = {
      edicao: false,
      editingSection: null,
      cpf: '',
      cpfErro: false,
      nome: '',
      nomeErro: false,
      emailPessoal: '',
      emailPessoalErro: false,
      emailProfissional: '',
      emailProfissionalErro: false,
      tipoVinculoList: [],
      tipoVinculo: '',
      tipoVinculoErro: false,
      jornadaTrabalho: '',
      jornadaTrabalhoErro: false,
      dataDesligamento: '',
      dataDesligamentoErro: false,
      sexo: '',
      exclusivo: '',
      projectList: [],
      project: '',
      projectErro: false,
      projetos: [],
      projetosErro: false,
      celular: '',
      telefone: '',
      telefoneErro: false,
      cep: '',
      cepErro: false,
      endereco: '',
      enderecoErro: false,
      numeroEndereco: '',
      numeroEnderecoErro: false,
      complemento: '',
      bairro: '',
      bairroErro: false,
      cidade: '',
      cidadeErro: false,
      uf: '',
      ufErro: false,
      trabalhaEscritorio: 'true',
      criaUsuarioSistema: '',
      perfil: '',
      perfilList: [],
      perfilErro: false,
      matricula: '',
      matriculaErro: false,
      custoMensal: '',
      custoMensalErro: false,
      isActive: this.dataDesligamento == null || this.dataDesligamento == '',
      cargo: '',
      cargoErro: false,
      codMeridional: '',
      // Deficiência (tipos do eSocial) e benefícios do contrato.
      pcd: false,
      pcdTipo: '',
      pcdDescricao: '',
      tituloEleitor: '',
      tituloZona: '',
      tituloSessao: '',
      dtExameAdmissional: '',
      temValeTransporte: false,
      temValeAlimentacao: false,
      temPlanoSaude: false,
      temSeguroVida: false,
      temAuxilioCreche: false,
      tarifasVt: [],
      vaOperadora: '',
      vaTipo: '',
      vaValorDia: '',
      diariaIntegraFerias: false,
      diariaIntegraDecimo: false,
      complementoIntegraFerias: false,
      complementoIntegraDecimo: false,
      cbo: '',
      escolaridade: '',
      racaCor: '',
      sindicato: '',
      dtAdmissao: moment().format('DD/MM/YYYY'),
      documentacao: [],
      linkDocumento: '',
      openHistoricoSalarial: false,
      openAlterarSalario: false,
      salarioAtual: '',
      motivoAlteracao: '',
      historicoSalarial: [],
      ultimaAlteracaoSalario: false,
      // Histórico salarial datado (tabela funcionario_salario_historico).
      // Campos com nome próprio de propósito: os de cima alimentam a tabela
      // antiga `salarios`, que não guarda data, e ficam intocados aqui.
      histSalarioAberto: false,
      histSalarioLista: [],
      histSalarioCarregando: false,
      histSalarioFormAberto: false,
      histSalarioValor: '',
      histSalarioData: moment().format('DD/MM/YYYY'),
      histSalarioMotivo: '',
      histSalarioAjuda: '',
      histSalarioComplemento: '',
      histSalarioSalvando: false,
      // Mudança de salário só vale depois que um sócio aprova: os pedidos da
      // pessoa vêm junto do histórico, e pode_aprovar diz se quem está logado
      // é sócio.
      histSalarioSolicitacoes: [],
      histSalarioPodeAprovar: false,
      histSalarioDecidindo: false,
      histSalarioRecusaId: null,
      histSalarioRecusaMotivo: '',
      alertaFerias: null,
      // Férias (funcionario_ferias)
      feriasAberto: false,
      feriasLista: [],
      feriasCarregando: false,
      feriasFormAberto: false,
      feriasAquisInicio: '',
      feriasAquisFim: '',
      feriasGozoInicio: '',
      feriasGozoFim: '',
      feriasDiasGozados: '',
      feriasDiasSaldo: '',
      feriasConcInicio: '',
      feriasConcFim: '',
      feriasDiasVendidos: '',
      feriasSalvando: false,
      // 13º salário (funcionario_decimo_terceiro)
      decTerAberto: false,
      decTerLista: [],
      decTerFinanceiro: [],
      decTerCarregando: false,
      decTerFormAberto: false,
      decTerAno: String(moment().year()),
      decTerValorAdiant: '',
      decTerDataAdiant: '',
      decTerValorSaldo: '',
      decTerDataSaldo: '',
      decTerValorRescisorio: '',
      decTerDataRescisorio: '',
      decTerSalvando: false,
      // Desligamento (funcionario_desligamento)
      desligAberto: false,
      desligLista: [],
      desligCarregando: false,
      desligFormAberto: false,
      desligData: '',
      desligMotivo: '',
      desligAviso: '',
      desligMulta: false,
      desligMultaPercentual: '',
      desligDiasAviso: '',
      desligDtAvisoInicio: '',
      desligDtAvisoFim: '',
      desligSalvando: false,
      openBeneficios: false,
      valorAlimentacao: '',
      valorRefeicao: '',
      valorTransporte: '',
      valorPlanoSaude: '',
      historicoBeneficios: [],
      tabIndex: 0,
      showBeneficios: false,
      savedBeneficios: {
        valorAlimentacao: '',
        valorRefeicao: '',
        valorTransporte: '',
        valorPlanoSaude: '',
      },
      nomeMae: '',
      nomePai: '',
      nacionalidade: '',
      rg: '',
      estadoCivil: '',
      cidadeNascimento: '',
      cnhCategoria: [],
      cnhDtEmissao: '',
      cnhDtVencimento: '',
      cnhNumero: '',
      ctpsNumero: '',
      ctpsSerie: '',
      pisNumero: '',
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleOpenHistoricoSalarial = () => {
    this.setState({ openHistoricoSalarial: true });
  };

  handleCloseHistoricoSalarial = () => {
    const { custoMensal, historicoSalarial } = this.state;
    if (historicoSalarial.length === 0) {
      this.setState({ custoMensalOriginal: custoMensal });
    }
    this.setState({ openHistoricoSalarial: false });
  };

  handleOpenAlterarSalario = () => {
    this.setState({
      openAlterarSalario: true,
      salarioAtual: '',
      motivoAlteracao: '',
    });
  };

  handleCloseAlterarSalario = () => {
    this.setState({ openAlterarSalario: false });
  };

  handleSalarioChange = (event) => {
    const salarioAtual = event.target.value;
    this.setState({ salarioAtual });
  };

  handleMotivoChange = (event) => {
    if (event.target.value.length <= 32) {
      this.setState({ motivoAlteracao: event.target.value });
    }
  };

  handleSaveSalario = () => {
    const { salarioAtual, motivoAlteracao, historicoSalarial, custoMensal } = this.state;

    if (!salarioAtual || !motivoAlteracao) {
      toast.error('Preenchimento obrigatório dos campos.');
      return;
    }

    const salarioAtualFloat = parseFloat(salarioAtual.replace(/[^\d,-]/g, '').replace(',', '.'));
    const novoHistorico = {
      salarioAnterior: `R$ ${custoMensal.toFixed(2).replace('.', ',')}`,
      salarioAtual: `R$ ${salarioAtualFloat.toFixed(2).replace('.', ',')}`,
      motivo: motivoAlteracao,
    };

    this.setState({
      custoMensal: salarioAtualFloat,
      historicoSalarial: [...historicoSalarial, novoHistorico],
      openAlterarSalario: false,
      ultimaAlteracaoSalario: true,
    }, () => {
      this.setState({ custoMensal: salarioAtualFloat });
    });
  };

  handleDeleteHistoricoSalarial = (index) => {
    const { historicoSalarial, custoMensalOriginal } = this.state;
    if (index === historicoSalarial.length - 1) {
      const updatedHistorico = historicoSalarial.filter((_, i) => i !== index);
      const ultimoHistorico = updatedHistorico[updatedHistorico.length - 1];
      const custoMensal = ultimoHistorico ? parseFloat(ultimoHistorico.salarioAtual.replace('R$ ', '').replace(/\./g, '').replace(',', '.')) : custoMensalOriginal;
      this.setState({ historicoSalarial: updatedHistorico, custoMensal, ultimaAlteracaoSalario: false });
    }
  };

  // --- Apoio comum das áreas da visão funcionário ---

  cpfFuncionario = () => this.state.cpf || this.props.funcionario;

  mensagemErro = (error, padrao) =>
    error && error.response && error.response.message ? error.response.message : padrao;

  handleVisaoFuncChange = (event) => {
    const { name, value, checked, type } = event.target;
    this.setState({ [name]: type === 'checkbox' ? checked : value });
  };

  // --- Férias (funcionario_ferias) ---

  abrirFerias = () => {
    this.setState({ feriasAberto: true, feriasFormAberto: false }, this.carregarFerias);
  };

  fecharFerias = () => {
    this.setState({ feriasAberto: false, feriasFormAberto: false });
  };

  carregarFerias = () => {
    const cpf = this.cpfFuncionario();
    if (!cpf) {
      return;
    }

    this.setState({ feriasCarregando: true });

    funcionarioAPI
      .getFerias(cpf)
      .then((r) => this.setState({ feriasLista: (r && r.request) || [], feriasCarregando: false }))
      .catch(() => {
        this.setState({ feriasCarregando: false, feriasLista: [] });
        toast.error('Não foi possível carregar as férias.');
      });
  };

  abrirFormFerias = () => {
    this.setState({
      feriasFormAberto: true,
      feriasAquisInicio: '',
      feriasAquisFim: '',
      feriasGozoInicio: '',
      feriasGozoFim: '',
      feriasDiasGozados: '',
      feriasDiasSaldo: '',
      feriasConcInicio: '',
      feriasConcFim: '',
      feriasDiasVendidos: '',
    });
  };

  salvarFerias = () => {
    const {
      feriasAquisInicio,
      feriasAquisFim,
      feriasGozoInicio,
      feriasGozoFim,
      feriasDiasGozados,
      feriasDiasSaldo,
      feriasConcInicio,
      feriasConcFim,
      feriasDiasVendidos,
    } = this.state;

    const obrigatorias = [
      [feriasAquisInicio, 'início do período aquisitivo'],
      [feriasAquisFim, 'fim do período aquisitivo'],
    ];

    for (let i = 0; i < obrigatorias.length; i += 1) {
      if (!moment(obrigatorias[i][0], 'DD/MM/YYYY', true).isValid()) {
        toast.error('Informe uma data válida (dd/mm/aaaa) para o ' + obrigatorias[i][1] + '.');
        return;
      }
    }

    const opcionais = [
      [feriasGozoInicio, 'início do gozo'],
      [feriasGozoFim, 'fim do gozo'],
      [feriasConcInicio, 'início do período concessivo'],
      [feriasConcFim, 'fim do período concessivo'],
    ];

    for (let i = 0; i < opcionais.length; i += 1) {
      if (opcionais[i][0] !== '' && !moment(opcionais[i][0], 'DD/MM/YYYY', true).isValid()) {
        toast.error('Informe uma data válida (dd/mm/aaaa) para o ' + opcionais[i][1] + ', ou deixe em branco.');
        return;
      }
    }

    this.setState({ feriasSalvando: true });

    funcionarioAPI
      .addFerias({
        cpf_funcionario: this.cpfFuncionario(),
        periodo_aquisitivo_inicio: Utils.dateToEN(feriasAquisInicio),
        periodo_aquisitivo_fim: Utils.dateToEN(feriasAquisFim),
        dt_gozo_inicio: feriasGozoInicio === '' ? '' : Utils.dateToEN(feriasGozoInicio),
        dt_gozo_fim: feriasGozoFim === '' ? '' : Utils.dateToEN(feriasGozoFim),
        dias_gozados: feriasDiasGozados === '' ? 0 : feriasDiasGozados,
        dias_saldo: feriasDiasSaldo === '' ? 0 : feriasDiasSaldo,
        periodo_concessivo_inicio: feriasConcInicio === '' ? '' : Utils.dateToEN(feriasConcInicio),
        periodo_concessivo_fim: feriasConcFim === '' ? '' : Utils.dateToEN(feriasConcFim),
        dias_vendidos: feriasDiasVendidos === '' ? 0 : feriasDiasVendidos,
      })
      .then((r) => {
        this.setState({
          feriasLista: (r && r.request) || [],
          feriasFormAberto: false,
          feriasSalvando: false,
        });
        toast.success('Férias registradas.');
      })
      .catch((error) => {
        this.setState({ feriasSalvando: false });
        toast.error(this.mensagemErro(error, 'Não foi possível registrar as férias.'));
      });
  };

  // --- 13º salário (funcionario_decimo_terceiro) ---

  abrirDecTer = () => {
    this.setState({ decTerAberto: true, decTerFormAberto: false }, this.carregarDecTer);
  };

  fecharDecTer = () => {
    this.setState({ decTerAberto: false, decTerFormAberto: false });
  };

  carregarDecTer = () => {
    const cpf = this.cpfFuncionario();
    if (!cpf) {
      return;
    }

    this.setState({ decTerCarregando: true });

    funcionarioAPI
      .getDecimoTerceiro(cpf)
      .then((r) =>
        this.setState({
          decTerLista: (r && r.request) || [],
          decTerFinanceiro: (r && r.financeiro) || [],
          decTerCarregando: false,
        })
      )
      .catch((error) => {
        this.setState({ decTerCarregando: false, decTerLista: [], decTerFinanceiro: [] });
        toast.error(this.mensagemErro(error, 'Não foi possível carregar o 13º salário.'));
      });
  };

  abrirFormDecTer = (registro, ano) => {
    this.setState({
      decTerFormAberto: true,
      decTerAno: registro ? String(registro.ano) : String(ano || moment().year()),
      decTerValorAdiant: registro && registro.valor_adiantamento ? parseFloat(registro.valor_adiantamento) : '',
      decTerDataAdiant: registro && registro.dt_pagamento_adiantamento ? Utils.dateToPT(registro.dt_pagamento_adiantamento) : '',
      decTerValorRescisorio: registro && registro.valor_rescisorio ? parseFloat(registro.valor_rescisorio) : '',
      decTerDataRescisorio: registro && registro.dt_pagamento_rescisorio ? Utils.dateToPT(registro.dt_pagamento_rescisorio) : '',
      decTerValorSaldo: registro && registro.valor_saldo ? parseFloat(registro.valor_saldo) : '',
      decTerDataSaldo: registro && registro.dt_pagamento_saldo ? Utils.dateToPT(registro.dt_pagamento_saldo) : '',
    });
  };

  salvarDecTer = () => {
    const {
      decTerAno,
      decTerValorAdiant,
      decTerDataAdiant,
      decTerValorRescisorio,
      decTerDataRescisorio,
    } = this.state;

    const ano = parseInt(decTerAno, 10);
    if (isNaN(ano) || ano < 1900 || ano > 2200) {
      toast.error('Informe um ano válido.');
      return;
    }

    const datasOpcionais = [
      [decTerDataAdiant, 'pagamento do adiantamento'],
      [decTerDataRescisorio, 'pagamento do proporcional rescisório'],
    ];

    for (let i = 0; i < datasOpcionais.length; i += 1) {
      if (datasOpcionais[i][0] !== '' && !moment(datasOpcionais[i][0], 'DD/MM/YYYY', true).isValid()) {
        toast.error('Informe uma data válida (dd/mm/aaaa) para o ' + datasOpcionais[i][1] + ', ou deixe em branco.');
        return;
      }
    }

    const valorAdiant = decTerValorAdiant === '' ? '' : Utils.moeda2float(decTerValorAdiant);
    const valorRescisorio = decTerValorRescisorio === '' ? '' : Utils.moeda2float(decTerValorRescisorio);

    if (valorAdiant === '' && decTerDataAdiant === '' && valorRescisorio === '' && decTerDataRescisorio === '') {
      toast.error('Informe ao menos um valor ou data.');
      return;
    }

    this.setState({ decTerSalvando: true });

    funcionarioAPI
      .addDecimoTerceiro({
        cpf_funcionario: this.cpfFuncionario(),
        ano: ano,
        valor_adiantamento: valorAdiant,
        dt_pagamento_adiantamento: decTerDataAdiant === '' ? '' : Utils.dateToEN(decTerDataAdiant),
        valor_rescisorio: valorRescisorio,
        dt_pagamento_rescisorio: decTerDataRescisorio === '' ? '' : Utils.dateToEN(decTerDataRescisorio),
      })
      .then(() => {
        this.setState({ decTerFormAberto: false, decTerSalvando: false });
        this.carregarDecTer();
        toast.success('13º salário registrado.');
      })
      .catch((error) => {
        this.setState({ decTerSalvando: false });
        toast.error(this.mensagemErro(error, 'Não foi possível registrar o 13º salário.'));
      });
  };

  // --- Desligamento (funcionario_desligamento) ---

  abrirDesligamento = () => {
    this.setState({ desligAberto: true, desligFormAberto: false }, this.carregarDesligamento);
  };

  fecharDesligamento = () => {
    this.setState({ desligAberto: false, desligFormAberto: false });
  };

  carregarDesligamento = () => {
    const cpf = this.cpfFuncionario();
    if (!cpf) {
      return;
    }

    this.setState({ desligCarregando: true });

    funcionarioAPI
      .getDesligamento(cpf)
      .then((r) => this.setState({ desligLista: (r && r.request) || [], desligCarregando: false }))
      .catch(() => {
        this.setState({ desligCarregando: false, desligLista: [] });
        toast.error('Não foi possível carregar os dados de desligamento.');
      });
  };

  // Regra informada pelo DP: 30 dias de aviso prévio, mais 3 por ano completo
  // de empresa, limitado a 90. Pela tabela de incidências, o aviso é integral só
  // na dispensa sem justa causa, metade no acordo, e não há aviso nos demais
  // motivos. Isto entra como SUGESTÃO — o campo continua editável, porque caso
  // fora da regra existe e precisa poder ser registrado.
  // Deficiência e benefícios no formato que AddFuncionario/EditFuncionario
  // esperam (ver server/funcionarios/CadastroCampos.php).
  // Campos de RH (CBO, escolaridade etc.) — usados no cadastro E na edição.
  // Antes só o cadastro mandava: a edição não enviava, o servidor gravava
  // vazio, e o CBO "sumia" depois de salvar.
  camposRhPayload = () => ({
    cod_meridional: this.state.codMeridional,
    cbo: this.state.cbo,
    escolaridade: this.state.escolaridade,
    raca_cor: this.state.racaCor,
    sindicato: this.state.sindicato,
    diaria_integra_ferias: this.state.diariaIntegraFerias,
    diaria_integra_decimo: this.state.diariaIntegraDecimo,
    complemento_integra_ferias: this.state.complementoIntegraFerias,
    complemento_integra_decimo: this.state.complementoIntegraDecimo,
  });

  camposExtrasPayload = () => ({
    pcd: this.state.pcd,
    pcd_tipo: this.state.pcd ? this.state.pcdTipo : '',
    pcd_descricao: this.state.pcd ? this.state.pcdDescricao : '',
    titulo_eleitor: this.state.tituloEleitor,
    titulo_zona: this.state.tituloZona,
    titulo_sessao: this.state.tituloSessao,
    dt_exame_admissional: this.state.dtExameAdmissional ? Utils.dateToEN(this.state.dtExameAdmissional) : '',
    tem_vale_transporte: this.state.temValeTransporte,
    tem_vale_alimentacao: this.state.temValeAlimentacao,
    tem_plano_saude: this.state.temPlanoSaude,
    tem_seguro_vida: this.state.temSeguroVida,
    tem_auxilio_creche: this.state.temAuxilioCreche,
    tarifas_vt: this.state.tarifasVt
      .filter((t) => !tarifaVazia(t))
      .map((t) => ({ operadora: t.operadora, valor: numeroBR(t.valor), viagens_dia: Number(t.viagens) })),
    // Só manda o cartão com o benefício marcado: desmarcar não apaga o que
    // estava cadastrado.
    ...(this.state.temValeAlimentacao
      ? {
          va_operadora: this.state.vaOperadora,
          va_tipo: vaPedeTipo(this.state.vaOperadora) ? this.state.vaTipo : '',
          va_valor_dia: this.state.vaOperadora ? numeroBR(this.state.vaValorDia) : '',
        }
      : {}),
  });

  checkHandleChange = (campo) => (evento) => {
    const marcado = evento.target.checked;
    this.setState((estado) => {
      const novo = { [campo]: marcado };
      // Ao marcar o VT já abre uma linha de passagem para preencher.
      if (campo === 'temValeTransporte' && marcado && estado.tarifasVt.length === 0) {
        novo.tarifasVt = [novaTarifaVt()];
      }
      return novo;
    });
  };

  alterarTarifaVt = (indice, campo) => (evento) => {
    const valor = evento.target.value;
    this.setState((estado) => ({
      tarifasVt: estado.tarifasVt.map((t, i) => (i === indice ? { ...t, [campo]: valor } : t)),
    }));
  };

  adicionarTarifaVt = () => {
    this.setState((estado) => ({ tarifasVt: [...estado.tarifasVt, novaTarifaVt()] }));
  };

  removerTarifaVt = (indice) => () => {
    this.setState((estado) => ({ tarifasVt: estado.tarifasVt.filter((_, i) => i !== indice) }));
  };

  diasAvisoSugeridos = (motivo) => {
    const admissao = moment(this.state.dtAdmissao, 'DD/MM/YYYY', true);
    const saida = moment(this.state.desligData, 'DD/MM/YYYY', true);

    if (!admissao.isValid() || !saida.isValid()) {
      return '';
    }

    const anosCompletos = Math.max(0, saida.diff(admissao, 'years'));
    const diasCheios = Math.min(30 + anosCompletos * 3, 90);

    if (motivo === 'sem_justa_causa') {
      return String(diasCheios);
    }
    if (motivo === 'acordo') {
      return String(Math.round(diasCheios / 2));
    }
    return '0';
  };

  // 40% na dispensa sem justa causa, 20% no acordo, nada nos demais.
  multaSugerida = (motivo) => {
    if (motivo === 'sem_justa_causa') {
      return '40';
    }
    if (motivo === 'acordo') {
      return '20';
    }
    return '0';
  };

  handleDesligMotivoChange = (event) => {
    const motivo = event.target.value;
    const percentual = this.multaSugerida(motivo);
    // Se o aviso prévio está como "Não se aplica", trocar o motivo não pode
    // ressuscitar a sugestão de dias — os campos de aviso seguem zerados.
    const semAviso = this.state.desligAviso === '';

    this.setState({
      desligMotivo: motivo,
      desligMultaPercentual: percentual,
      desligDiasAviso: semAviso ? '0' : this.diasAvisoSugeridos(motivo),
      desligMulta: parseFloat(percentual) > 0,
    });
  };

  // "Não se aplica" limpa e trava dias/datas de aviso, para não gravar um
  // desligamento dizendo que não há aviso prévio mas com 33 dias registrados.
  // Ao voltar para trabalhado/indenizado os campos reabrem e a sugestão de
  // dias é recalculada a partir do motivo.
  handleDesligAvisoChange = (event) => {
    const aviso = event.target.value;

    if (aviso === '') {
      this.setState({
        desligAviso: '',
        desligDiasAviso: '0',
        desligDtAvisoInicio: '',
        desligDtAvisoFim: '',
      });
      return;
    }

    this.setState({
      desligAviso: aviso,
      desligDiasAviso: this.diasAvisoSugeridos(this.state.desligMotivo),
    });
  };

  abrirFormDesligamento = () => {
    this.setState({
      desligFormAberto: true,
      desligData: this.state.dataDesligamento || moment().format('DD/MM/YYYY'),
      desligMotivo: '',
      desligAviso: '',
      desligMulta: false,
      desligMultaPercentual: '',
      desligDiasAviso: '0',
      desligDtAvisoInicio: '',
      desligDtAvisoFim: '',
    });
  };

  salvarDesligamento = () => {
    const {
      desligData,
      desligMotivo,
      desligAviso,
      desligMulta,
      desligMultaPercentual,
      desligDiasAviso,
      desligDtAvisoInicio,
      desligDtAvisoFim,
    } = this.state;

    if (!moment(desligData, 'DD/MM/YYYY', true).isValid()) {
      toast.error('Informe uma data de desligamento válida (dd/mm/aaaa).');
      return;
    }

    if (!desligMotivo) {
      toast.error('Escolha o motivo do desligamento.');
      return;
    }

    this.setState({ desligSalvando: true });

    funcionarioAPI
      .addDesligamento({
        cpf_funcionario: this.cpfFuncionario(),
        dt_desligamento: Utils.dateToEN(desligData),
        motivo: desligMotivo,
        tipo_aviso_previo: desligAviso,
        multa_fgts_devida: desligMulta,
        multa_fgts_percentual: desligMultaPercentual,
        dias_aviso_previo: desligDiasAviso,
        dt_aviso_previo_inicio: desligDtAvisoInicio === '' ? '' : Utils.dateToEN(desligDtAvisoInicio),
        dt_aviso_previo_fim: desligDtAvisoFim === '' ? '' : Utils.dateToEN(desligDtAvisoFim),
      })
      .then((r) => {
        // O servidor também preenche a data de desligamento na ficha, então a
        // tela acompanha: a pessoa passa a aparecer como desligada.
        this.setState({
          desligLista: (r && r.request) || [],
          desligFormAberto: false,
          desligSalvando: false,
          dataDesligamento: desligData,
          isActive: false,
        });
        toast.success('Desligamento registrado.');
      })
      .catch((error) => {
        this.setState({ desligSalvando: false });
        toast.error(this.mensagemErro(error, 'Não foi possível registrar o desligamento.'));
      });
  };

  // --- Histórico salarial datado (funcionario_salario_historico) ---

  abrirHistoricoSalario = () => {
    this.setState(
      { histSalarioAberto: true, histSalarioFormAberto: false },
      this.carregarHistoricoSalario
    );
  };

  fecharHistoricoSalario = () => {
    this.setState({ histSalarioAberto: false, histSalarioFormAberto: false });
  };

  carregarHistoricoSalario = () => {
    const cpf = this.state.cpf || this.props.funcionario;
    if (!cpf) {
      return;
    }

    this.setState({ histSalarioCarregando: true });

    funcionarioAPI
      .getHistoricoSalarial(cpf)
      .then((response) => {
        this.setState({
          histSalarioLista: (response && response.request) || [],
          histSalarioSolicitacoes: (response && response.solicitacoes) || [],
          histSalarioPodeAprovar: !!(response && response.pode_aprovar),
          histSalarioCarregando: false,
        });
      })
      .catch(() => {
        this.setState({ histSalarioCarregando: false, histSalarioLista: [], histSalarioSolicitacoes: [] });
        toast.error('Não foi possível carregar o histórico salarial.');
      });
  };

  abrirFormNovoSalario = (valorInicial) => {
    this.setState({
      histSalarioFormAberto: true,
      histSalarioValor: valorInicial || '',
      histSalarioData: moment().format('DD/MM/YYYY'),
      histSalarioMotivo: '',
      histSalarioAjuda: '',
      histSalarioComplemento: '',
    });
  };

  fecharFormNovoSalario = () => {
    this.setState({ histSalarioFormAberto: false });
  };

  handleHistSalarioChange = (event) => {
    const { name, value } = event.target;
    if (name === 'histSalarioMotivo' && value.length > 100) {
      return;
    }
    this.setState({ [name]: value });
  };

  salvarNovoSalario = () => {
    const cpf = this.state.cpf || this.props.funcionario;
    const {
      histSalarioValor,
      histSalarioData,
      histSalarioMotivo,
      histSalarioAjuda,
      histSalarioComplemento,
    } = this.state;

    const valor = Utils.moeda2float(histSalarioValor);
    // Ajuda de custo e complemento são opcionais: vazio vai como null.
    const opcional = (v) => {
      const n = Utils.moeda2float(v);
      return n === '' || isNaN(n) ? null : n;
    };
    if (!valor || isNaN(valor) || valor <= 0) {
      toast.error('Informe o valor do novo salário.');
      return;
    }

    if (!moment(histSalarioData, 'DD/MM/YYYY', true).isValid()) {
      toast.error('Informe uma data válida (dd/mm/aaaa) para o início da vigência.');
      return;
    }

    if (!histSalarioMotivo || histSalarioMotivo.trim() === '') {
      toast.error('Informe o motivo da alteração.');
      return;
    }

    this.setState({ histSalarioSalvando: true });

    funcionarioAPI
      .addSalarioHistorico({
        cpf_funcionario: cpf,
        salario: valor,
        dt_vigencia_inicio: Utils.dateToEN(histSalarioData),
        motivo: histSalarioMotivo.trim(),
        valor_ajuda_custo: opcional(histSalarioAjuda),
        valor_complemento: opcional(histSalarioComplemento),
      })
      .then((response) => {
        // O pedido não muda o histórico nem a ficha: só a aprovação muda.
        this.setState({
          histSalarioLista: (response && response.request) || [],
          histSalarioSolicitacoes: (response && response.solicitacoes) || [],
          histSalarioPodeAprovar: !!(response && response.pode_aprovar),
          histSalarioFormAberto: false,
          histSalarioSalvando: false,
        });
        toast.success('Mudança de salário enviada para aprovação de um sócio.');
      })
      .catch((error) => {
        this.setState({ histSalarioSalvando: false });
        const mensagem =
          error && error.response && error.response.message
            ? error.response.message
            : 'Não foi possível registrar o salário.';
        toast.error(mensagem);
      });
  };

  // Aprovar ou recusar (só sócio; o servidor confere) e cancelar o pedido.
  decidirSalario = (solicitacao, decisao) => {
    const motivo = this.state.histSalarioRecusaMotivo.trim();
    if (decisao === 'recusar' && !motivo) {
      toast.error('Informe o motivo da recusa.');
      return;
    }

    this.setState({ histSalarioDecidindo: true });
    funcionarioAPI
      .decidirSalario(solicitacao.id, decisao, motivo)
      .then((response) => {
        const novoEstado = {
          histSalarioLista: (response && response.request) || [],
          histSalarioDecidindo: false,
          histSalarioRecusaId: null,
          histSalarioRecusaMotivo: '',
        };
        // Aprovado com vigência já começada: a ficha passa a mostrar o novo
        // salário, como o servidor gravou.
        if (response && response.custo_total_mensal_atualizado) {
          novoEstado.custoMensal = parseFloat(response.salario);
        }
        this.setState(novoEstado, this.carregarHistoricoSalario);
        toast.success((response && response.message) || 'Decisão registrada.');
      })
      .catch((error) => {
        this.setState({ histSalarioDecidindo: false });
        toast.error(
          (error && error.response && error.response.message) ||
            'Não foi possível registrar a decisão.'
        );
      });
  };

  handleOpenBeneficios = () => {
    this.setState({
      openBeneficios: true,
      valorAlimentacao: '',
      valorRefeicao: '',
      valorTransporte: '',
      valorPlanoSaude: '',
    });
  };

  handleCloseBeneficios = () => {
    this.setState({ openBeneficios: false });
  };

  handleBeneficioChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  handleSaveBeneficios = () => {
    const { valorAlimentacao, valorRefeicao, valorTransporte, valorPlanoSaude } = this.state;

    if (!valorAlimentacao && !valorRefeicao && !valorTransporte && !valorPlanoSaude) {
      toast.error('Por favor, preencha todos os campos antes de salvar.');
      return;
    }

    const novoHistorico = {
      valorAlimentacao: valorAlimentacao || this.state.savedBeneficios.valorAlimentacao,
      valorRefeicao: valorRefeicao || this.state.savedBeneficios.valorRefeicao,
      valorTransporte: valorTransporte || this.state.savedBeneficios.valorTransporte,
      valorPlanoSaude: valorPlanoSaude || this.state.savedBeneficios.valorPlanoSaude,
      data: new Date().toLocaleString(),
    };

    this.setState({
      historicoBeneficios: [...this.state.historicoBeneficios, novoHistorico],
      showBeneficios: true,
      savedBeneficios: novoHistorico,
    });
  };

  handleTabChange = (event, newValue) => {
    this.setState({ tabIndex: newValue });
  };

  componentDidMount() {
    this.getTipoVinculo();
    this.getProjetos();
    this.getPerfis();
    this.setState({ custoMensalOriginal: this.state.custoMensal });

    this.setState({ ultimaAlteracaoSalario: false });

    if (this.props.pageMode && this.props.edicao) {
      this.setState({ edicao: true }, () => this.getFuncionarioData());
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.edicao !== this.props.edicao) {
      this.setState(
        {
          edicao: this.props.edicao,
          isActive:
            this.dataDesligamento == null || this.dataDesligamento == '',
        },
        () => {
          if (this.props.edicao) {
            this.getFuncionarioData();
          } else {
            this.setState({
              valorAlimentacao: '',
              valorRefeicao: '',
              valorTransporte: '',
              valorPlanoSaude: '',
              savedBeneficios: {
                valorAlimentacao: '',
                valorRefeicao: '',
                valorTransporte: '',
                valorPlanoSaude: '',
              },
              showBeneficios: false,
            });
          }
        }
      );
    }
  }

  getTipoVinculo = () => {
    AppState.isLoading = true;
    fetch(
      `${AppState.serverAddr}/funcionarios/GetTipoVinculoList.php`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          Authorization: AppState.token,
        },
      }
    )
      .then((response) => {
        if (!response.ok) {
          return response.json().then((json) => {
            let error = new Error(response.status);
            error.response = json;
            throw error;
          });
        } else {
          const res = response.json();
          return res;
        }
      })
      .then((response) => {
        AppState.isLoading = false;
        this.setState({
          tipoVinculoList: response.request,
        });
      })

      .catch(function (error) {
        AppState.isLoading = false;
        if (error.toString() == '' || error.toString().split(' ').length < 2) {
          toast.error('Erro desconhecido, tente novamente');
          return;
        }
        var Err_status = error.toString().split(' ')[1];
        if (Err_status == 400) {
          var ret = error.response['status'].value.split(' ')[0];
          if (ret == '40001') {
            console.log('40001 - Erro desconhecido');
          } else toast.error('Dados inválidos');
        } else if (Err_status == 401) {
          browserHistory.push(`${process.env.PUBLIC_URL}/logout`);
        } else if (Err_status == 500) {
          toast.error('Erro desconhecido, tente novamente');
        }
      });
  };

  getProjetos = () => {
    AppState.isLoading = true;
    fetch(
      `${AppState.serverAddr}/projetos/GetProjects.php`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          Authorization: AppState.token,
        },
      }
    )
      .then((response) => {
        if (!response.ok) {
          return response.json().then((json) => {
            let error = new Error(response.status);
            error.response = json;
            throw error;
          });
        } else {
          const res = response.json();
          return res;
        }
      })
      .then((response) => {
        AppState.isLoading = false;
        this.setState({
          projectList: response.request,
        });
      })

      .catch(function (error) {
        AppState.isLoading = false;
        if (error.toString() == '' || error.toString().split(' ').length < 2) {
          toast.error('Erro desconhecido, tente novamente');
          return;
        }
        var Err_status = error.toString().split(' ')[1];
        if (Err_status == 400) {
          var ret = error.response['status'].value.split(' ')[0];
          if (ret == '40001') {
            console.log('40001 - Erro desconhecido');
          } else toast.error('Erro ao processar, por favor tente novamente');
        } else if (Err_status == 401) {
          browserHistory.push(`${process.env.PUBLIC_URL}/logout`);
        } else if (Err_status == 500) {
          toast.error('Erro desconhecido, tente novamente');
        }
      });
  };

  getPerfis = () => {
    AppState.isLoading = true;
    fetch(
      `${AppState.serverAddr}/comum/GetPerfisAcesso.php`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          Authorization: AppState.token,
        },
      }
    )
      .then((response) => {
        if (!response.ok) {
          return response.json().then((json) => {
            let error = new Error(response.status);
            error.response = json;
            throw error;
          });
        } else {
          const res = response.json();
          return res;
        }
      })
      .then((response) => {
        AppState.isLoading = false;
        this.setState({
          perfilList: response.request,
        });
      })

      .catch(function (error) {
        AppState.isLoading = false;
        if (error.toString() == '' || error.toString().split(' ').length < 2) {
          toast.error('Erro desconhecido, tente novamente');
          return;
        }
        var Err_status = error.toString().split(' ')[1];
        if (Err_status == 400) {
          var ret = error.response['status'].value.split(' ')[0];
          if (ret == '40001') {
            console.log('40001 - Erro desconhecido');
          } else toast.error('Erro ao processar, por favor tente novamente');
        } else if (Err_status == 401) {
          browserHistory.push(`${process.env.PUBLIC_URL}/logout`);
        } else if (Err_status == 500) {
          toast.error('Erro desconhecido, tente novamente');
        }
      });
  };

  // Aviso de prazo de férias (23 meses desde as últimas gozadas). Quem não tem
  // férias registradas não gera aviso — ver GetAlertasFerias.php.
  carregarAlertaFerias = () => {
    const cpf = this.cpfFuncionario();
    if (!cpf) {
      return;
    }

    funcionarioAPI
      .getAlertasFerias(cpf)
      .then((r) => {
        const lista = (r && r.request) || [];
        this.setState({ alertaFerias: lista.length > 0 ? lista[0] : null });
      })
      .catch(() => {
        this.setState({ alertaFerias: null });
      });
  };

  getFuncionarioData = () => {
    AppState.isLoading = true;
    this.carregarAlertaFerias();
    fetch(
      `${AppState.serverAddr}/funcionarios/GetFuncionario.php?json={"cpf_funcionario":"${this.props.funcionario}"}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          Authorization: AppState.token,
        },
      }
    )
      .then((response) => {
        if (!response.ok) {
          return response.json().then((json) => {
            let error = new Error(response.status);
            error.response = json;
            throw error;
          });
        } else {
          return response.json();
        }
      })
      .then((response) => {
        AppState.isLoading = false;

        const linkDocumentacao = JSON.parse(response.request[0].link_documentacao) || [];
        const documentacaoArray = linkDocumentacao
          .filter(link => link && link.trim() !== '')
          .map((link) => {
            const nomeArquivo = link.split('/').pop();
            return { name: nomeArquivo, link };
          });

        const historicoSalarial = response.request[0].salarios.map((item) => ({
          salarioAnterior: `R$ ${parseFloat(item.salario_anterior).toFixed(2).replace('.', ',')}`,
          salarioAtual: `R$ ${parseFloat(item.salario_atual).toFixed(2).replace('.', ',')}`,
          motivo: item.motivo,
        })) || [];

        const beneficiosData = response.request[0].beneficios;
        let beneficios = { vale_alimentacao: "0.00", vale_refeicao: "0.00", vale_transporte: "0.00", plano_saude: "0.00" };
        if (beneficiosData && Array.isArray(beneficiosData) && beneficiosData.length > 0) {
          beneficios = beneficiosData[0];
        }

        const formatCurrency = (value) => {
          const number = parseFloat(value);
          return number.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        };



        const savedBenefits = {
          valorAlimentacao: formatCurrency(beneficios.vale_alimentacao || 0),
          valorRefeicao: formatCurrency(beneficios.vale_refeicao || 0),
          valorTransporte: formatCurrency(beneficios.vale_transporte || 0),
          valorPlanoSaude: formatCurrency(beneficios.plano_saude || 0),
        };



        const hasBenefits =
          parseFloat(savedBenefits.valorAlimentacao) > 0 ||
          parseFloat(savedBenefits.valorRefeicao) > 0 ||
          parseFloat(savedBenefits.valorTransporte) > 0 ||
          parseFloat(savedBenefits.valorPlanoSaude) > 0;

        this.setState({
          nome: response.request[0].nome_funcionario || '',
          matricula: response.request[0].matricula_funcionario || '',
          cpf: response.request[0].cpf_funcionario || '',
          sexo: response.request[0].sexo || '',
          bairro: response.request[0].bairro_residencia || '',
          celular: response.request[0].celular || '',
          telefone: response.request[0].tel_residencia || '',
          emailPessoal: response.request[0].email_pessoal || '',
          emailProfissional: response.request[0].email_profissional || '',
          dtAdmissao: Utils.dateToPT(response.request[0].dt_admissao),
          dataDesligamento: Utils.dateToPT(response.request[0].dt_demissao),
          dataNascimento: Utils.dateToPT(response.request[0].dt_nascimento),
          uf: response.request[0].uf_residencia || '',
          cep: response.request[0].cep_residencia || '',
          endereco: response.request[0].end_residencia || '',
          numeroEndereco: response.request[0].numero_residencia || '',
          complemento: response.request[0].complemento_residencia || '',
          cidade: response.request[0].cidade_residencia || '',
          cidade_nascimento: response.request[0].cidade_nascimento || '',
          tipoVinculo: response.request[0].tipo_vinculo || '',
          jornadaTrabalho: response.request[0].jornada_diaria_trabalho || '',
          custoMensal: parseFloat(response.request[0].custo_total_mensal),
          // "Projeto Atual" sai da associação feita em Sistema > Usuários
          // (tabela usuario_projeto), que o GetFuncionario já devolve em
          // projetos_autorizados. Antes não era preenchido e o campo aparecia
          // sempre vazio. Campo próprio de exibição: state.project guarda o ID
          // e é usado pelo seletor "Selecione o Projeto", não pode virar texto.
          projetoAtualNome: (response.request[0].projetos_autorizados || [])
            .map((p) => p.desc_curta)
            .filter((d) => d)
            .join(', '),
          // Alocação atual carregada no formulário. Antes ela não era lida, e
          // salvar a ficha mandava uma lista vazia de projetos — agora que o
          // servidor passou a gravar essa lista, abrir e salvar sem carregar
          // apagaria a alocação da pessoa.
          //
          // id_projeto 0 é o marcador que update_user_projects grava para
          // "não exclusivo"; não é projeto de verdade, então não entra na lista.
          ...alocacaoDoFuncionario(response.request[0].projetos_autorizados),
          isActive: response.request[0].dt_demissao === null,
          cargo: response.request[0].cargo || '',
          ...lerCamposExtras(response.request[0]),
          codMeridional: response.request[0].cod_meridional || '',
          diariaIntegraFerias: response.request[0].diaria_integra_ferias === true || response.request[0].diaria_integra_ferias === 't',
          diariaIntegraDecimo: response.request[0].diaria_integra_decimo === true || response.request[0].diaria_integra_decimo === 't',
          complementoIntegraFerias: response.request[0].complemento_integra_ferias === true || response.request[0].complemento_integra_ferias === 't',
          complementoIntegraDecimo: response.request[0].complemento_integra_decimo === true || response.request[0].complemento_integra_decimo === 't',
          cbo: response.request[0].cbo || '',
          escolaridade: response.request[0].escolaridade || '',
          racaCor: response.request[0].raca_cor || '',
          sindicato: response.request[0].sindicato || '',
          linkDocumento: response.request[0].link_documentacao || '',
          documentacao: documentacaoArray,
          historicoSalarial: historicoSalarial,
          ultimaAlteracaoSalario: false,
          valorAlimentacao: savedBenefits.valorAlimentacao,
          valorRefeicao: savedBenefits.valorRefeicao,
          valorTransporte: savedBenefits.valorTransporte,
          valorPlanoSaude: savedBenefits.valorPlanoSaude,
          savedBeneficios: savedBenefits,
          showBeneficios: hasBenefits,
          nomeMae: response.request[0].nome_mae || '',
          nomePai: response.request[0].nome_pai || '',
          nacionalidade: response.request[0].nacionalidade || '',
          rg: response.request[0].rg_numero || '',
          estadoCivil: response.request[0].estado_civil || '',
          perfil: response.request[0].perfil || '',
          cnhCategoria: response.request[0].cnh_categoria ? response.request[0].cnh_categoria.split(',').map(c => c.trim()) : [],
          cnhDtEmissao: Utils.dateToPT(response.request[0].cnh_dt_emissao),
          cnhDtVencimento: Utils.dateToPT(response.request[0].cnh_dt_vencimento),
          cnhNumero: response.request[0].cnh_numero || '',
          ctpsNumero: response.request[0].ctps_numero || '',
          ctpsSerie: response.request[0].ctps_serie || '',
          pisNumero: response.request[0].pis_numero || '',
        });
      })
      .catch((error) => {
        AppState.isLoading = false;
        console.error('Erro ao buscar dados do funcionário:', error);
      });
  };



  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  statusHandleChange = (event) => {
    if (event.target.checked) {
      this.setState({
        isActive: event.target.checked,
        dataDesligamento: '',
      });
    } else {
      this.setState({
        isActive: event.target.checked,
        dataDesligamento: Utils.dateToPT(
          new Date(
            new Date().getTime() - new Date().getTimezoneOffset() * 60000
          )
            .toISOString()
            .slice(0, 10)
        ),
      });
    }
  };

  projetosHandleChange = (event) => {
    if (event.target.value && event.target.value.length > 0) {
      this.setState({
        projetos: event.target.value,
      });
    }
  };

  exclusivoHandleChange = (event) => {
    this.setState({
      project: '',
      projetoAtualNome: '',
      projetos: [],
      exclusivo: event.target.value,
    });
  };

  closeDialog = () => {
    this.setState(
      {
        edicao: false,
        cpf: '',
        cpfErro: false,
        nome: '',
        nomeErro: false,
        emailPessoal: '',
        emailPessoalErro: false,
        emailProfissional: '',
        emailProfissionalErro: false,
        tipoVinculo: '',
        tipoVinculoErro: false,
        jornadaTrabalho: '',
        jornadaTrabalhoErro: false,
        dataDesligamento: '',
        dataDesligamentoErro: false,
        sexo: '',
        exclusivo: '',
        project: '',
        projectErro: false,
        projetos: [],
        projetosErro: false,
        celular: '',
        telefone: '',
        telefoneErro: false,
        cep: '',
        cargo: '',
        cargoErro: false,
        codMeridional: '',
        pcd: false,
        pcdTipo: '',
        pcdDescricao: '',
        tituloEleitor: '',
        tituloZona: '',
        tituloSessao: '',
        dtExameAdmissional: '',
        temValeTransporte: false,
        temValeAlimentacao: false,
        temPlanoSaude: false,
        temSeguroVida: false,
        temAuxilioCreche: false,
        tarifasVt: [],
        vaOperadora: '',
        vaTipo: '',
        vaValorDia: '',
        diariaIntegraFerias: false,
        diariaIntegraDecimo: false,
        complementoIntegraFerias: false,
        complementoIntegraDecimo: false,
        cbo: '',
        escolaridade: '',
        racaCor: '',
        sindicato: '',
        cepErro: false,
        endereco: '',
        enderecoErro: false,
        numeroEndereco: '',
        numeroEnderecoErro: false,
        complemento: '',
        cidade: '',
        bairro: '',
        bairroErro: false,
        cidadeErro: false,
        uf: '',
        ufErro: false,
        trabalhaEscritorio: 'true',
        criaUsuarioSistema: '',
        perfil: '',
        perfilErro: false,
        matricula: '',
        matriculaErro: false,
        custoMensal: '',
        custoMensalErro: false,
        dtAdmissao: moment().format('DD/MM/YYYY'),
        dtAdmissaoErro: false,
        documentacao: [],
        linkDocumento: '',
        valorAlimentacao: '',
        valorRefeicao: '',
        valorTransporte: '',
        valorPlanoSaude: '',
        savedBeneficios: {
          valorAlimentacao: '',
          valorRefeicao: '',
          valorTransporte: '',
          valorPlanoSaude: '',
        },
        historicoBeneficios: [],
        showBeneficios: false,
      },
      () => this.props.close()
    );
  };

  getEndereco = (cep) => {
    AppState.isLoading = true;
    fetch(`https://viacep.com.br/ws/${cep}/json/`, {
      method: 'GET',
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((json) => {
            let error = new Error(response.status);
            error.response = json;
            throw error;
          });
        } else {
          const res = response.json();
          return res;
        }
      })
      .then((response) => {
        AppState.isLoading = false;
        this.setState({
          endereco: response.logradouro,
          bairro: response.bairro,
          cidade: response.localidade,
          uf: response.uf,
        });

        if (response.erro == true) {
          this.setState({
            endereco: '',
            bairro: '',
            cidade: '',
            uf: '',
          });
        }
      });
  };


  addFuncionario = () => {
    AppState.isLoading = true;

    const data = JSON.stringify({
      cpf: this.state.cpf,
      nome: this.state.nome,
      matricula: this.state.matricula,
      sexo: this.state.sexo,
      email_pessoal: this.state.emailPessoal,
      email_profissional: this.state.emailProfissional,
      cel: this.state.celular,
      tel_residencia: this.state.telefone,
      tipo_vinculo: this.state.tipoVinculo,
      jornada_horas: this.state.jornadaTrabalho,
      custo_mensal: Utils.moeda2float(this.state.custoMensal),
      dt_admissao: Utils.dateToEN(this.state.dtAdmissao),
      dt_desligamento: Utils.dateToEN(this.state.dataDesligamento),
      dt_nascimento: Utils.dateToEN(this.state.dataNascimento),
      cep: this.state.cep,
      endereco: this.state.endereco,
      end_numero: this.state.numeroEndereco,
      end_bairro: this.state.bairro,
      end_complemento: this.state.complemento,
      cidade: this.state.cidade,
      uf: this.state.uf,
      perfil: this.state.perfil,
      projetos: this.state.projetos.length < 1 ? [{ id_projeto: this.state.project }] : this.state.projetos,
      ativo: 'true',
      exclusivo: this.state.exclusivo,
      cargo: this.state.cargo,
      ...this.camposExtrasPayload(),
      ...this.camposRhPayload(),
      beneficios: {
        vale_alimentacao: this.state.valorAlimentacao
          ? parseFloat(this.state.valorAlimentacao.replace('R$', '').replace(/\./g, '').replace(',', '.'))
          : 0.00,
        vale_refeicao: this.state.valorRefeicao
          ? parseFloat(this.state.valorRefeicao.replace('R$', '').replace(/\./g, '').replace(',', '.'))
          : 0.00,
        vale_transporte: this.state.valorTransporte
          ? parseFloat(this.state.valorTransporte.replace('R$', '').replace(/\./g, '').replace(',', '.'))
          : 0.00,
        plano_saude: this.state.valorPlanoSaude
          ? parseFloat(this.state.valorPlanoSaude.replace('R$', '').replace(/\./g, '').replace(',', '.'))
          : 0.00,
      },
      nome_mae: this.state.nomeMae,
      nome_pai: this.state.nomePai,
      nacionalidade: this.state.nacionalidade,
      rg: this.state.rg,
      estado_civil: this.state.estadoCivil,
      cidade_nascimento: this.state.cidadeNascimento,
      cnh_categoria: Array.isArray(this.state.cnhCategoria) ? this.state.cnhCategoria.join(', ') : this.state.cnhCategoria,
      cnh_dt_emissao: Utils.dateToEN(this.state.cnhDtEmissao),
      cnh_dt_vencimento: Utils.dateToEN(this.state.cnhDtVencimento),
      cnh_numero: this.state.cnhNumero,
      ctpsNumero: this.state.ctpsNumero,
      ctpsSerie: this.state.ctpsSerie,
      pisNumero: this.state.pisNumero,
    });

    console.log('Dados do funcionário em JSON:', data);

    const documentacaoData = new FormData();
    documentacaoData.append('json', data);

    (this.state.documentacao || []).forEach((file, index) => {
      if (file && file.file) {
        documentacaoData.append(`file_${index}`, file.file);
      }
    });

    funcionarioAPI
      .addFuncionario(documentacaoData)
      .then((response) => {
        AppState.isLoading = false;
        // Cadastro feito pela página (layout da ficha): abre a ficha da
        // pessoa recém-cadastrada.
        if (this.props.pageMode) {
          toast.success('Funcionário cadastrado.');
          browserHistory.push(`${process.env.PUBLIC_URL}/funcionarios/${this.state.cpf}`);
          return;
        }
        this.props.carregaTabela();
        this.closeDialog();
      })
      .catch((error) => {
        AppState.isLoading = false;

        // A API devolve o corpo do erro em error.response (sem .data).
        const errorData = error && error.response ? error.response.data || error.response : null;
        if (!errorData) {
          toast.error('Erro desconhecido, tente novamente.');
          return;
        }

        const errCode = errorData.code;
        const errMessage = errorData.message || 'Erro desconhecido.';

        toast.error(errMessage);

        if (error.response.status === 401) {
          const logoutUrl =
            process.env.NODE_ENV === 'development'
              ? "http://localhost:3000/logout"
              : `${process.env.PUBLIC_URL}/logout`;
          window.location.href = logoutUrl;
        }
      });
  };



  editFuncionario = () => {
    AppState.isLoading = true;

    const validLinks = Array.isArray(this.state.documentacao)
      ? this.state.documentacao
        .filter((doc) => !doc.preview || doc.link)
        .map((doc) => doc.link || '')
      : [];

    const data = JSON.stringify({
      cpf: this.state.cpf,
      nome: this.state.nome,
      matricula: this.state.matricula,
      sexo: this.state.sexo,
      email_pessoal: this.state.emailPessoal,
      email_profissional: this.state.emailProfissional,
      cel: this.state.celular,
      tel_residencia: this.state.telefone,
      projeto_vinculado: this.state.project,
      tipo_vinculo: this.state.tipoVinculo,
      jornada_horas: this.state.jornadaTrabalho,
      custo_mensal: Utils.moeda2float(this.state.custoMensal),
      historico_salarial: this.state.ultimaAlteracaoSalario ? this.state.historicoSalarial.map((item) => ({
        salario_anterior: parseFloat(
          item.salarioAnterior.replace('R$ ', '').replace(',', '.')
        ),
        salario_atual: parseFloat(
          item.salarioAtual.replace('R$ ', '').replace(',', '.')
        ),
        motivo: item.motivo,
      })) : [],
      dt_admissao: Utils.dateToEN(this.state.dtAdmissao),
      dt_desligamento: Utils.dateToEN(this.state.dataDesligamento),
      dt_nascimento: Utils.dateToEN(this.state.dataNascimento),
      cep: this.state.cep,
      endereco: this.state.endereco,
      end_bairro: this.state.bairro,
      end_numero: this.state.numeroEndereco,
      end_complemento: this.state.complemento,
      cidade: this.state.cidade,
      uf: this.state.uf,
      perfil: this.state.perfil,
      // Mesma regra do cadastro: com projeto único, manda o do seletor.
      projetos:
        this.state.projetos.length < 1
          ? this.state.project
            ? [{ id_projeto: this.state.project }]
            : []
          : this.state.projetos,
      exclusivo: this.state.exclusivo,
      cargo: this.state.cargo,
      ...this.camposExtrasPayload(),
      ...this.camposRhPayload(),
      link_documento: validLinks,
      beneficios: {
        vale_alimentacao: this.state.valorAlimentacao
          ? parseFloat(this.state.valorAlimentacao.replace('R$', '').replace(/\./g, '').replace(',', '.'))
          : parseFloat(this.state.savedBeneficios.valorAlimentacao.replace('R$', '').replace(/\./g, '').replace(',', '.')),
        vale_refeicao: this.state.valorRefeicao
          ? parseFloat(this.state.valorRefeicao.replace('R$', '').replace(/\./g, '').replace(',', '.'))
          : parseFloat(this.state.savedBeneficios.valorRefeicao.replace('R$', '').replace(/\./g, '').replace(',', '.')),
        vale_transporte: this.state.valorTransporte
          ? parseFloat(this.state.valorTransporte.replace('R$', '').replace(/\./g, '').replace(',', '.'))
          : parseFloat(this.state.savedBeneficios.valorTransporte.replace('R$', '').replace(/\./g, '').replace(',', '.')),
        plano_saude: this.state.valorPlanoSaude
          ? parseFloat(this.state.valorPlanoSaude.replace('R$', '').replace(/\./g, '').replace(',', '.'))
          : parseFloat(this.state.savedBeneficios.valorPlanoSaude.replace('R$', '').replace(/\./g, '').replace(',', '.')),
      },
      nome_mae: this.state.nomeMae,
      nome_pai: this.state.nomePai,
      nacionalidade: this.state.nacionalidade,
      rg: this.state.rg,
      estado_civil: this.state.estadoCivil,
      cidade_nascimento: this.state.cidadeNascimento,
      cnh_categoria: Array.isArray(this.state.cnhCategoria) ? this.state.cnhCategoria.join(', ') : this.state.cnhCategoria,
      cnh_dt_emissao: Utils.dateToEN(this.state.cnhDtEmissao),
      cnh_dt_vencimento: Utils.dateToEN(this.state.cnhDtVencimento),
      cnh_numero: this.state.cnhNumero,
      ctpsNumero: this.state.ctpsNumero,
      ctpsSerie: this.state.ctpsSerie,
      pisNumero: this.state.pisNumero,
    });

    console.log('Dados enviados ao backend:', data);

    const documentoData = new FormData();
    documentoData.append('json', data);

    (this.state.documentacao || []).forEach((doc, index) => {
      if (doc.file) {
        documentoData.append(`file_${index}`, doc.file);
      }
    });

    funcionarioAPI
      .editFuncionario(documentoData)
      .then((response) => {
        AppState.isLoading = false;

        // Na página de detalhe cada card salva pra este mesmo endpoint (não existe salvar só um
        // pedaço), mas não navega pra lista nem limpa o formulário como o modal faz — só fecha a edição do card.
        if (this.props.pageMode) {
          this._editSectionSnapshot = null;
          toast.success('Dados atualizados com sucesso.');
          this.setState({ editingSection: null });
          return;
        }

        this.props.carregaTabela();
        this.closeDialog();
      })
      .catch((error) => {
        AppState.isLoading = false;

        // A API devolve o corpo do erro (JSON) em error.response e o status
        // HTTP em error.message. Mostra a mensagem que o servidor mandou.
        const status = Number(error && error.message);
        const corpo = error && error.response ? error.response : null;

        if (status === 401) {
          if (process.env.NODE_ENV === 'development') {
            window.location.href = "http://localhost:3000/logout";
          } else {
            window.location.href = `${process.env.PUBLIC_URL}/logout`;
          }
          return;
        }

        toast.error((corpo && corpo.message) || 'Erro ao salvar o funcionário, tente novamente.');
      });
  };



  validaForm = () => {
    let formValido = true;

    if (!this.state.cpf || this.state.cpf == '' || this.state.cpf.length < 11) {
      formValido = false;
      this.setState({
        cpfErro: true,
      });
    }

    if (!this.state.nome || this.state.nome == '') {
      formValido = false;
      this.setState({
        nomeErro: true,
      });
    }

    if (this.state.tipoVinculo == '') {
      formValido = false;
      this.setState({
        tipoVinculoErro: true,
      });
    }

    if (this.state.cargo == '') {
      formValido = false;
      this.setState({
        cargoErro: true,
      });
    }

    if (this.state.matricula == '') {
      formValido = false;
      this.setState({
        matriculaErro: true,
      });
    }

    if (!this.state.emailProfissional || this.state.emailProfissional == '') {
      formValido = false;
      this.setState({
        emailProfissionalErro: true,
      });
    }

    if (this.state.jornadaTrabalho == '') {
      formValido = false;
      this.setState({
        jornadaTrabalhoErro: true,
      });
    }

    if (!this.state.custoMensal || this.state.custoMensal == '') {
      formValido = false;
      this.setState({
        custoMensalErro: true,
      });
    }

    if (this.state.cep == '' || this.state.cep.length < 9) {
      formValido = false;
      this.setState({
        cepErro: true,
      });
    }

    if (this.state.endereco == '') {
      formValido = false;
      this.setState({
        enderecoErro: true,
      });
    }

    if (this.state.bairro == '') {
      formValido = false;
      this.setState({
        bairroErro: true,
      });
    }

    if (this.state.numeroEndereco == '') {
      formValido = false;
      this.setState({
        numeroEnderecoErro: true,
      });
    }

    if (this.state.cidade == '') {
      formValido = false;
      this.setState({
        cidadeErro: true,
      });
    }

    if (this.state.uf == '' || this.state.uf.length != 2) {
      formValido = false;
      this.setState({
        ufErro: true,
      });
    }

    if (this.state.sexo == '') {
      formValido = false;
      toast.error('Por favor informe o sexo do funcionário.');
      this.setState({
        sexoErro: true,
      });
    }

    if (
      !this.state.dtAdmissao ||
      !moment(this.state.dtAdmissao, 'DD/MM/YYYY', true).isValid()
    ) {
      formValido = false;
      this.setState({
        dtAdmissaoErro: true,
      });
    }

    if (!this.state.edicao) {
      if (this.state.perfil == '') {
        formValido = false;
        this.setState({
          perfilErro: true,
        });
      }

      if (this.state.exclusivo == 'true') {
        if (this.state.project == '') {
          formValido = false;
          this.setState({
            projectErro: true,
          });
        }
      } else {
        if (this.state.projetos.length <= 0) {
          formValido = false;
          this.setState({
            projetosErro: true,
          });
        }
      }
    }

    const erroVt = erroTarifasVt(this.state.tarifasVt);
    if (erroVt) {
      formValido = false;
      toast.error(erroVt);
    }
    const erroVa = erroValeAlimentacao(this.state);
    if (erroVa) {
      formValido = false;
      toast.error(erroVa);
    }

    if (formValido) {
      if (this.state.edicao) {
        this.editFuncionario();
      } else {
        this.addFuncionario();
      }
    }
  };

  CEPhandleChange = (event) => {
    this.setState(
      {
        cep: event.target.value,
      },
      () => {
        if (this.state.cep.length === 9) {
          this.getEndereco(this.state.cep.replace('-', ''));
        }
      }
    );
  };

  deleteDocumentacaoChip = (index) => {
    const arr = [...this.state.documentacao];
    arr.splice(index, 1);

    this.setState({
      documentacao: arr,
      linkDocumento: arr.length > 0 ? this.state.linkDocumento : null,
    });
  };

  handleDocumentacaoFile = (event) => {
    event.preventDefault();
    const files = Array.from(this.documentoInput.current.files);
    const tenMbInKb = 25000;

    const validFiles = files.filter((file) => {
      const sizeInKb = file.size / 1000;
      if (sizeInKb > tenMbInKb) {
        toast.error(`O arquivo ${file.name} deve ser inferior a 25MB.`);
        return false;
      }
      return true;
    });

    if (validFiles.length > 0) {

      const filesWithPreview = validFiles.map((file) => ({
        name: file.name,
        size: file.size,
        file,
        preview: URL.createObjectURL(file),
      }));

      this.setState((prevState) => ({
        documentacao: [...(prevState.documentacao || []), ...filesWithPreview],
      }));
    }

    event.target.value = null;
  };

  // Guarda uma cópia do estado ao abrir um card pra edição, pra "Cancelar" conseguir desfazer
  // sem precisar recarregar os dados do funcionário do servidor.
  startEditSection = (section) => {
    this._editSectionSnapshot = { ...this.state };
    this.setState({ editingSection: section });
  };

  cancelEditSection = () => {
    const snapshot = this._editSectionSnapshot;
    this._editSectionSnapshot = null;
    this.setState(snapshot ? { ...snapshot, editingSection: null } : { editingSection: null });
  };

  // Botão "Editar" (vira "Cancelar"/"Salvar" quando esse card é o que está em edição) no
  // cabeçalho de cada card da página de detalhe. Só um card edita por vez.
  // Pedidos de mudança de salário da pessoa: o pendente com os botões de
  // decisão e, abaixo, os recusados (com o motivo) para o DP ver o porquê.
  renderSolicitacoesSalario = () => {
    const lista = this.state.histSalarioSolicitacoes || [];
    const pendentes = lista.filter((x) => x.status === 'pendente');
    const recusadas = lista.filter((x) => x.status === 'recusada').slice(0, 3);
    const moeda = (v) => (v != null ? 'R$ ' + Utils.float2moeda(parseFloat(v)) : null);
    const decidindo = this.state.histSalarioDecidindo;

    return (
      <React.Fragment>
        {pendentes.map((x) => (
          <div
            key={x.id}
            style={{
              border: '1px solid #f0c36d',
              background: '#fff8e1',
              borderRadius: 8,
              padding: 12,
              marginBottom: 16,
            }}
          >
            <strong>Aguardando aprovação de um sócio</strong>
            <div style={{ marginTop: 6 }}>
              {moeda(x.salario)} a partir de {Utils.dateToPT(x.dt_vigencia_inicio)}
              {x.valor_ajuda_custo != null ? ` · ajuda de custo ${moeda(x.valor_ajuda_custo)}` : ''}
              {x.valor_complemento != null ? ` · complemento ${moeda(x.valor_complemento)}` : ''}
              {` · ${x.motivo}`}
            </div>
            <div style={{ color: '#666', fontSize: 13, marginTop: 4 }}>
              Pedido por {x.solicitado_por_nome || x.solicitado_por || '-'} em{' '}
              {Utils.dateToPT(String(x.dt_solicitacao).slice(0, 10))}
              {x.origem === 'importacao' ? ' (importação)' : ''}
            </div>

            {this.state.histSalarioRecusaId === x.id ? (
              <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end', marginTop: 12 }}>
                <TextField
                  fullWidth
                  label={'Motivo da recusa'}
                  value={this.state.histSalarioRecusaMotivo}
                  onChange={(e) => this.setState({ histSalarioRecusaMotivo: e.target.value.slice(0, 255) })}
                />
                <DsButton
                  type="button"
                  intent="secondary"
                  disabled={decidindo}
                  onClick={() => this.setState({ histSalarioRecusaId: null, histSalarioRecusaMotivo: '' })}
                >
                  Voltar
                </DsButton>
                <DsButton
                  type="button"
                  intent="primary"
                  disabled={decidindo}
                  onClick={() => this.decidirSalario(x, 'recusar')}
                >
                  Confirmar recusa
                </DsButton>
              </div>
            ) : (
              <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 12 }}>
                <DsButton
                  type="button"
                  intent="text"
                  disabled={decidindo}
                  onClick={() => this.decidirSalario(x, 'cancelar')}
                >
                  Cancelar pedido
                </DsButton>
                {this.state.histSalarioPodeAprovar && (
                  <React.Fragment>
                    <DsButton
                      type="button"
                      intent="secondary"
                      disabled={decidindo}
                      onClick={() => this.setState({ histSalarioRecusaId: x.id, histSalarioRecusaMotivo: '' })}
                    >
                      Recusar
                    </DsButton>
                    <DsButton
                      type="button"
                      intent="primary"
                      disabled={decidindo}
                      onClick={() => this.decidirSalario(x, 'aprovar')}
                    >
                      Aprovar
                    </DsButton>
                  </React.Fragment>
                )}
              </div>
            )}
          </div>
        ))}

        {recusadas.length > 0 && (
          <div style={{ color: '#666', fontSize: 13, marginBottom: 16 }}>
            {recusadas.map((x) => (
              <div key={x.id}>
                Recusado por {x.decidido_por_nome || x.decidido_por || '-'}: {moeda(x.salario)} a partir de{' '}
                {Utils.dateToPT(x.dt_vigencia_inicio)} — {x.motivo_recusa}
              </div>
            ))}
          </div>
        )}
      </React.Fragment>
    );
  };

  renderSectionActions = (section) => {
    if (this.state.editingSection === section) {
      return (
        <div style={{ display: 'flex', gap: 8 }}>
          <DsButton intent="secondary" onClick={this.cancelEditSection}>Cancelar</DsButton>
          <DsButton intent="primary" onClick={this.validaForm}>Salvar</DsButton>
        </div>
      );
    }

    return (
      <DsButton
        intent="text"
        disabled={!!this.state.editingSection}
        onClick={() => this.startEditSection(section)}
      >
        Editar
      </DsButton>
    );
  };

  render() {
    const { pageMode } = this.props;
    // Cadastro novo na página: mesmo layout em cards da ficha, mas com todos
    // os campos abertos para preencher e um Salvar no fim, em vez do
    // visualizar/editar por card.
    const novo = pageMode && !this.props.edicao;
    const leitura = (secao) => pageMode && !novo && this.state.editingSection !== secao;
    const acoesSecao = (secao) => (pageMode && !novo ? this.renderSectionActions(secao) : null);

    // Em pageMode cada seção vira um card (Panel) com botão Editar no cabeçalho; no modal de
    // cadastro mantém o título solto (SectionTitle) como sempre foi, sem alternar visualizar/editar.
    const formContent = (
          <form id={this.constructor.name}>
            {pageMode && (
              <Breadcrumb
                items={[
                  {
                    label: 'Funcionários',
                    onClick: () =>
                      browserHistory.push(`${process.env.PUBLIC_URL}/funcionarios`),
                  },
                  { label: novo ? 'Novo funcionário' : this.state.nome || 'Funcionário' },
                ]}
              />
            )}
            <Grid
              container={true}
              alignItems={'flex-start'}
              justify={'space-around'}
              direction={'row'}
              spacing={40}
            >
              <Grid
                item
                sm={10}
                container
                direction="row"
                justify="space-between"
                style={{ maxWidth: '100%', flexGrow: '1', flexBasis: 'auto', flexWrap: 'nowrap' }}
              >
                <div style={{ width: '100%' }}>
                  <PageTitle style={pageMode ? { marginBottom: 4 } : undefined}>
                    {novo
                      ? 'Novo funcionário'
                      : pageMode
                      ? this.state.nome || 'Funcionário'
                      : 'Cadastro de Funcionários'}
                  </PageTitle>

                  {this.state.alertaFerias && (() => {
                    const alerta = this.state.alertaFerias;
                    const vencido = alerta.dias_restantes < 0;

                    return (
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          marginTop: 8,
                          marginBottom: 8,
                          padding: '10px 14px',
                          borderRadius: 4,
                          border: '1px solid ' + (vencido ? '#c0392b' : '#e0a800'),
                          backgroundColor: vencido ? '#fdeceb' : '#fff8e1',
                          color: vencido ? '#8c291f' : '#6b5200',
                          fontSize: 14,
                        }}
                      >
                        <Icon style={{ marginRight: 8 }}>
                          {vencido ? 'error_outline' : 'warning'}
                        </Icon>
                        <span>
                          <strong>
                            {vencido ? 'Prazo de férias vencido' : 'Prazo de férias se aproximando'}
                          </strong>
                          {' — '}
                          {vencido
                            ? `venceu em ${Utils.dateToPT(alerta.dt_limite)}, há ${Math.abs(alerta.dias_restantes)} dia(s).`
                            : `vence em ${Utils.dateToPT(alerta.dt_limite)}, faltam ${alerta.dias_restantes} dia(s).`}
                          {' '}
                          {alerta.ultima_ferias
                            ? `Últimas férias terminaram em ${Utils.dateToPT(alerta.ultima_ferias)}.`
                            : 'Não há férias gozadas registradas.'}
                        </span>
                      </div>
                    );
                  })()}

                  {pageMode && !novo && (() => {
                    // Linha simples de resumo embaixo do nome — sem card, sem fundo branco, texto e tags separados por "·".
                    const summaryItems = [
                      this.state.cargo,
                      this.state.tipoVinculo && (
                        <Tag tone={toneForVinculo(this.state.tipoVinculo)} dot={false}>{this.state.tipoVinculo}</Tag>
                      ),
                      this.state.matricula && `Matrícula ${this.state.matricula}`,
                      this.state.dtAdmissao && `Admissão em ${this.state.dtAdmissao}`,
                      <Tag tone={this.state.isActive ? 'green' : 'red'}>
                        {this.state.isActive ? 'Ativo' : 'Desligado'}
                      </Tag>,
                    ].filter(Boolean);

                    return (
                      <div
                        style={{
                          display: 'flex',
                          flexWrap: 'wrap',
                          alignItems: 'center',
                          justifyContent: 'flex-start',
                          gap: 8,
                          color: '#6b6b6b',
                          fontSize: '1.05em',
                        }}
                      >
                        {summaryItems.map((item, index) => (
                          <React.Fragment key={index}>
                            {index > 0 && <span style={{ color: '#d8d8db' }}>·</span>}
                            {item}
                          </React.Fragment>
                        ))}
                      </div>
                    );
                  })()}
                </div>
                {!pageMode && <Icon onClick={this.closeDialog}>close</Icon>}
              </Grid>

              <Grid item md={pageMode ? 6 : 4} style={{ width: '100%' }}>
                <SecaoFicha pageMode={pageMode} title="Dados Profissionais" actions={acoesSecao('profissionais')}>
                {leitura('profissionais') ? (
                  <div>
                    <FieldRow label="CPF" value={this.state.cpf || '—'} />
                    <FieldRow
                      label="Status"
                      value={
                        <Tag tone={this.state.isActive ? 'green' : 'red'}>
                          {this.state.isActive ? 'Ativo' : 'Desligado'}
                        </Tag>
                      }
                    />
                    <FieldRow label="Nome Completo" value={this.state.nome || '—'} />
                    <FieldRow
                      label="Tipo de Vínculo"
                      value={
                        this.state.tipoVinculo ? (
                          <Tag tone={toneForVinculo(this.state.tipoVinculo)} dot={false}>{this.state.tipoVinculo}</Tag>
                        ) : (
                          '—'
                        )
                      }
                    />
                    <FieldRow label="Matrícula" value={this.state.matricula || '—'} />
                    <FieldRow label="Cargo" value={this.state.cargo || '—'} />
                    <FieldRow label="E-mail Profissional" value={this.state.emailProfissional || '—'} />
                    <FieldRow label="CTPS Número" value={this.state.ctpsNumero || '—'} />
                    <FieldRow label="CTPS Série" value={this.state.ctpsSerie || '—'} />
                    <FieldRow label="Data de Admissão" value={this.state.dtAdmissao || '—'} />
                    <FieldRow label="Exame Admissional" value={this.state.dtExameAdmissional || '—'} />
                    {this.state.isActive === false && (
                      <FieldRow label="Data de Desligamento" value={this.state.dataDesligamento || '—'} />
                    )}
                    <FieldRow
                      label="Jornada de Trabalho"
                      value={this.state.jornadaTrabalho ? `0${this.state.jornadaTrabalho} Horas Diárias` : '—'}
                    />
                    <FieldRow label="Salário" value={this.state.custoMensal || '—'} />
                    <FieldRow
                      label="Benefícios"
                      value={
                        BENEFICIOS_CADASTRO.filter(([estado]) => this.state[estado])
                          .map(([, , rotuloBeneficio]) => rotuloBeneficio)
                          .join(', ') || 'Nenhum'
                      }
                    />
                    {this.state.temValeTransporte && (
                      <FieldRow label="Vale-transporte" value={textoTarifasVt(this.state.tarifasVt)} />
                    )}
                    {this.state.temValeAlimentacao && (
                      <FieldRow label="Vale-alimentação" value={textoValeAlimentacao(this.state)} />
                    )}
                    <FieldRow
                      label="Sexo"
                      value={this.state.sexo === 'M' ? 'Masculino' : this.state.sexo === 'F' ? 'Feminino' : '—'}
                    />
                  </div>
                ) : (
                <React.Fragment>
                <Grid container spacing={16}>
                  <Grid item md={5}>
                    <FormControl fullWidth={true}>
                      <TextField
                        label={'CPF'}
                        name={'cpf'}
                        onChange={this.handleChange}
                        value={this.state.cpf}
                        error={this.state.cpfErro}
                        InputProps={{
                          inputComponent: this.state.cpf.length > 14 ? CPFMaskCustomEdit : CPFMaskCustom,
                          readOnly: this.props.edicao,
                        }}
                      />
                    </FormControl>
                  </Grid>
                  {/* Ativo/desligado só faz sentido para quem já existe:
                      cadastro novo é sempre ativo. */}
                  {this.state.edicao && (
                    <Grid item md={7} style={{ marginTop: '10px' }}>
                      <Switch
                        value={this.state.isActive}
                        color={'primary'}
                        checked={this.state.isActive}
                        onChange={this.statusHandleChange}
                      />
                      <InputLabel>Funcionário {this.state.isActive ? 'Ativo' : 'Desligado'}</InputLabel>
                    </Grid>
                  )}
                </Grid>

                <FormControl fullWidth={true}>
                  <TextField label={'Nome Completo'} name={'nome'} value={this.state.nome} onChange={this.handleChange} error={this.state.nomeErro} />
                </FormControl>

                <Grid container spacing={16}>
                  <Grid item md={6} style={styles.halfGrid}>
                    <FormControl fullWidth={true}>
                      <InputLabel htmlFor="type_of_link">Tipo de Vínculo</InputLabel>
                      <Select value={this.state.tipoVinculo} inputProps={{ name: 'tipoVinculo' }} error={this.state.tipoVinculoErro} onChange={this.handleChange}>
                        {this.state.tipoVinculoList.map((item, index) => (
                          <MenuItem value={item.tipo_vinculo} key={index}>{item.tipo_vinculo}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <FormControl fullWidth={true}>
                      <TextField label={'Matrícula'} name={'matricula'} value={this.state.matricula} onChange={this.handleChange} error={this.state.matriculaErro} />
                    </FormControl>
                  </Grid>
                </Grid>

                <FormControl fullWidth={true}>
                  <TextField type="text" label={'Cargo'} name={'cargo'} value={this.state.cargo} onChange={this.handleChange} error={this.state.cargoErro} />
                </FormControl>

                {/* Campos pedidos pelo RH (migracao 2026-09-23). Todos
                    opcionais: ninguem fica impedido de cadastrar alguem por nao
                    ter o CBO em maos na hora. */}
                <Grid container spacing={16}>
                  <Grid item md={6} xs={12}>
                    <FormControl fullWidth={true}>
                      <TextField type="text" label={'Cód. Meridional'} name={'codMeridional'} value={this.state.codMeridional} onChange={this.handleChange} />
                    </FormControl>
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <FormControl fullWidth={true}>
                      <TextField type="text" label={'CBO'} name={'cbo'} value={this.state.cbo} onChange={this.handleChange} />
                    </FormControl>
                  </Grid>
                </Grid>

                <Grid container spacing={16}>
                  <Grid item md={4} xs={12}>
                    <FormControl fullWidth={true}>
                      <InputLabel htmlFor="escolaridade">Escolaridade</InputLabel>
                      <Select value={this.state.escolaridade} inputProps={{ name: 'escolaridade' }} onChange={this.handleChange}>
                        {opcoesComAtual(OPCOES_ESCOLARIDADE, this.state.escolaridade).map((op) => (
                          <MenuItem key={op} value={op}>{op}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <FormControl fullWidth={true}>
                      <InputLabel htmlFor="racaCor">Raça e cor</InputLabel>
                      <Select value={this.state.racaCor} inputProps={{ name: 'racaCor' }} onChange={this.handleChange}>
                        {opcoesComAtual(OPCOES_RACA_COR, this.state.racaCor).map((op) => (
                          <MenuItem key={op} value={op}>{op}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <FormControl fullWidth={true}>
                      <TextField type="text" label={'Sindicato'} name={'sindicato'} value={this.state.sindicato} onChange={this.handleChange} />
                    </FormControl>
                  </Grid>
                </Grid>

                {/* Verbas habituais. Diária/ajuda de custo e complemento só
                    entram na base de férias e 13º quando são habituais, e isso
                    é característica do contrato desta pessoa — por isso fica
                    aqui, marcado uma vez, e não em cada lançamento.
                    Começa desmarcado de propósito: presumir que integra
                    inflaria a provisão do passivo de todo mundo. */}
                <InputLabel style={{ fontSize: 13, marginTop: 16 }}>
                  Verbas que integram a base de férias e 13º
                </InputLabel>
                <Grid container spacing={16}>
                  <Grid item md={6} xs={12}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          checked={this.state.diariaIntegraFerias}
                          onChange={this.checkHandleChange('diariaIntegraFerias')}
                        />
                      }
                      label="Diária/ajuda de custo integra férias"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          checked={this.state.diariaIntegraDecimo}
                          onChange={this.checkHandleChange('diariaIntegraDecimo')}
                        />
                      }
                      label="Diária/ajuda de custo integra 13º"
                    />
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          checked={this.state.complementoIntegraFerias}
                          onChange={this.checkHandleChange('complementoIntegraFerias')}
                        />
                      }
                      label="Complemento integra férias"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          checked={this.state.complementoIntegraDecimo}
                          onChange={this.checkHandleChange('complementoIntegraDecimo')}
                        />
                      }
                      label="Complemento integra 13º"
                    />
                  </Grid>
                </Grid>

                {/* Benefícios que o contrato dá. O que foi pago no mês sai dos
                    lançamentos (Visão de Pessoas › Benefícios). */}
                <InputLabel style={{ fontSize: 13, marginTop: 16 }}>Benefícios</InputLabel>
                <Grid container spacing={0}>
                  {BENEFICIOS_CADASTRO.map(([estado, , rotuloBeneficio]) => (
                    <Grid item md={4} xs={6} key={estado}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            color="primary"
                            checked={this.state[estado]}
                            onChange={this.checkHandleChange(estado)}
                          />
                        }
                        label={rotuloBeneficio}
                      />
                    </Grid>
                  ))}
                </Grid>

                {/* Passagens do dia para o pedido de VT (Visão de Pessoas ›
                    Benefícios › Vale-transporte). */}
                {this.state.temValeTransporte && (
                  <div style={{ margin: '8px 0 16px', padding: '8px 12px', border: '1px solid #e0e0e0', borderRadius: 4 }}>
                    <InputLabel style={{ fontSize: 13 }}>Passagens por dia (vale-transporte)</InputLabel>
                    {this.state.tarifasVt.map((t, i) => (
                      <Grid container spacing={16} alignItems="flex-end" key={i}>
                        <Grid item md={4} xs={12}>
                          <FormControl fullWidth={true}>
                            <InputLabel>Cartão</InputLabel>
                            <Select value={t.operadora} onChange={this.alterarTarifaVt(i, 'operadora')}>
                              {OPERADORAS_VT.map(([op, rotulo]) => (
                                <MenuItem key={op} value={op}>{rotulo}</MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item md={3} xs={5}>
                          <FormControl fullWidth={true}>
                            <TextField
                              label="Valor (R$)"
                              placeholder="7,90"
                              value={t.valor}
                              onChange={this.alterarTarifaVt(i, 'valor')}
                            />
                          </FormControl>
                        </Grid>
                        <Grid item md={3} xs={5}>
                          <FormControl fullWidth={true}>
                            <TextField
                              label="Vezes por dia"
                              type="number"
                              inputProps={{ min: 1, max: 20 }}
                              value={t.viagens}
                              onChange={this.alterarTarifaVt(i, 'viagens')}
                            />
                          </FormControl>
                        </Grid>
                        <Grid item md={2} xs={2}>
                          <DsButton type="button" intent="text" onClick={this.removerTarifaVt(i)}>Remover</DsButton>
                        </Grid>
                      </Grid>
                    ))}
                    <div style={{ marginTop: 8, display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                      <DsButton type="button" intent="secondary" onClick={this.adicionarTarifaVt}>Adicionar passagem</DsButton>
                      <span style={{ fontSize: 13, color: '#666', marginLeft: 16 }}>{textoTarifasVt(this.state.tarifasVt)}</span>
                    </div>
                  </div>
                )}

                {/* Cartão do pedido de alimentação/refeição (Visão de Pessoas ›
                    Benefícios › Alimentação e refeição). */}
                {this.state.temValeAlimentacao && (
                  <div style={{ margin: '8px 0 16px', padding: '8px 12px', border: '1px solid #e0e0e0', borderRadius: 4 }}>
                    <InputLabel style={{ fontSize: 13 }}>Vale-alimentação / refeição</InputLabel>
                    <Grid container spacing={16} alignItems="flex-end">
                      <Grid item md={4} xs={12}>
                        <FormControl fullWidth={true}>
                          <InputLabel>Cartão</InputLabel>
                          <Select
                            value={this.state.vaOperadora}
                            onChange={(e) => this.setState({ vaOperadora: e.target.value })}
                          >
                            {OPERADORAS_VA.map(([op, rotulo]) => (
                              <MenuItem key={op} value={op}>{rotulo}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      {vaPedeTipo(this.state.vaOperadora) && (
                        <Grid item md={4} xs={6}>
                          <FormControl fullWidth={true}>
                            <InputLabel>Tipo</InputLabel>
                            <Select
                              value={this.state.vaTipo}
                              onChange={(e) => this.setState({ vaTipo: e.target.value })}
                            >
                              {TIPOS_VA.map(([t, rotulo]) => (
                                <MenuItem key={t} value={t}>{rotulo}</MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                      )}
                      <Grid item md={4} xs={6}>
                        <FormControl fullWidth={true}>
                          <TextField
                            label="Valor por dia (R$)"
                            placeholder="50,00"
                            value={this.state.vaValorDia}
                            onChange={(e) => this.setState({ vaValorDia: e.target.value })}
                          />
                        </FormControl>
                      </Grid>
                    </Grid>
                    <div style={{ fontSize: 13, color: '#666', marginTop: 8 }}>
                      {this.state.vaOperadora === 'ifood' ? 'iFood vale para alimentação e refeição. ' : ''}
                      O profissional paga o valor de 1 dia; o resto é da empresa (estagiário: tudo da empresa).
                    </div>
                  </div>
                )}

                <FormControl fullWidth={true}>
                  <TextField type="email" label={'E-mail Profissional'} name={'emailProfissional'} value={this.state.emailProfissional} onChange={this.handleChange} error={this.state.emailProfissionalErro} />
                </FormControl>

                <Grid container spacing={16}>
                  <Grid item md={6}>
                    <FormControl fullWidth={true}>
                      <TextField label={'CTPS Número'} name={'ctpsNumero'} value={this.state.ctpsNumero} onChange={this.handleChange} error={this.state.ctpsNumeroErro} InputProps={{ inputComponent: ElevenDigitsMaskCustom }}/>
                    </FormControl>
                  </Grid>
                  <Grid item md={6} >
                    <FormControl fullWidth={true}>
                      <TextField label={'CTPS Série'} name={'ctpsSerie'} value={this.state.ctpsSerie} onChange={this.handleChange} error={this.state.ctpsSerieErro} InputProps={{ inputComponent: FourDigitsMaskCustom }}/>
                    </FormControl>
                  </Grid>
                </Grid>

                <Grid container spacing={16} style={{ marginTop: '2px' }}>
                  <Grid item md={this.state.isActive === false ? 6 : 12}>
                    <FormControl fullWidth={true}>
                      <TextField label={'Data de Admissão'} value={this.state.dtAdmissao} name={'dtAdmissao'} onChange={this.handleChange} InputProps={{ inputComponent: DateMaskCustom }} error={this.state.dtAdmissaoErro} />
                    </FormControl>
                  </Grid>
                  <Grid item md={this.state.isActive === false ? 6 : 12}>
                    <FormControl fullWidth={true}>
                      <TextField label={'Data do Exame Admissional'} value={this.state.dtExameAdmissional} name={'dtExameAdmissional'} onChange={this.handleChange} InputProps={{ inputComponent: DateMaskCustom }} />
                    </FormControl>
                  </Grid>
                  {this.state.isActive === false && (
                    <Grid item md={6}>
                      <FormControl fullWidth={true}>
                        <TextField label={'Data de Desligamento'} value={this.state.dataDesligamento} name={'dataDesligamento'} InputProps={{ inputComponent: DateMaskCustom }} onChange={this.handleChange} error={this.state.dataDesligamentoErro} disabled={this.state.edicao} />
                      </FormControl>
                      {this.state.edicao && (
                        <DsButton
                          type="button"
                          intent="outlined"
                          onClick={this.abrirDesligamento}
                          style={{ marginTop: 8, whiteSpace: 'nowrap' }}
                        >
                          Detalhes do desligamento
                        </DsButton>
                      )}
                    </Grid>
                  )}
                </Grid>

                <Grid container spacing={16}>
                  <Grid item md={6} style={styles.halfGrid}>
                    <FormControl fullWidth={true}>
                      <InputLabel htmlFor="type_of_link">Jornada de Trabalho</InputLabel>
                      <Select value={this.state.jornadaTrabalho} inputProps={{ name: 'jornadaTrabalho' }} error={this.state.jornadaTrabalhoErro} onChange={this.handleChange}>
                        {[2, 3, 4, 5, 6, 7, 8].map(h => <MenuItem value={h} key={h}>{`0${h} Horas Diárias`}</MenuItem>)}
                      </Select>
                    </FormControl>
                    <div style={{ display: 'flex', alignItems: 'flex-end', gap: 8 }}>
                      <FormControl fullWidth={true} style={{ flex: 1 }}>
                        <CurrencyInput label={'Salário'} name={'salario'} value={this.state.custoMensal} onChange={this.handleChange} error={this.state.custoMensalErro} disabled={this.state.edicao} />
                      </FormControl>
                      {this.state.edicao && (
                        <DsButton
                          type="button"
                          intent="outlined"
                          onClick={this.abrirHistoricoSalario}
                          style={{ marginBottom: 4, whiteSpace: 'nowrap' }}
                        >
                          Histórico
                        </DsButton>
                      )}
                    </div>
                  </Grid>
                </Grid>

                {this.state.edicao && (
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 16 }}>
                    <DsButton type="button" intent="outlined" onClick={this.abrirFerias}>
                      Férias
                    </DsButton>
                    <DsButton type="button" intent="outlined" onClick={this.abrirDecTer}>
                      13º salário
                    </DsButton>
                  </div>
                )}

                <FormControl>
                  <FormLabel style={{ display: 'inline-block', marginTop: '16px' }}>Sexo</FormLabel>
                  <RadioGroup name="sexo" row={true} value={this.state.sexo} onChange={this.handleChange}>
                    <FormControlLabel value="M" control={<Radio color={'primary'} />} label="Masculino" />
                    <FormControlLabel value="F" control={<Radio color={'primary'} />} label="Feminino" />
                  </RadioGroup>
                </FormControl>
                </React.Fragment>
                )}
                </SecaoFicha>
              </Grid>

              <Grid item md={pageMode ? 6 : 4} style={{ width: '100%' }}>
                <SecaoFicha pageMode={pageMode} title="Dados Pessoais" actions={acoesSecao('pessoais')}>
                {leitura('pessoais') ? (
                  <div>
                    <FieldRow label="Nome Mãe" value={this.state.nomeMae || '—'} />
                    <FieldRow label="Nome Pai" value={this.state.nomePai || '—'} />
                    <FieldRow label="Estado Civil" value={this.state.estadoCivil || '—'} />
                    <FieldRow label="Nacionalidade" value={this.state.nacionalidade || '—'} />
                    <FieldRow label="PIS" value={this.state.pisNumero || '—'} />
                    <FieldRow
                      label="Título de Eleitor"
                      value={
                        this.state.tituloEleitor
                          ? [
                              this.state.tituloEleitor,
                              this.state.tituloZona && `zona ${this.state.tituloZona}`,
                              this.state.tituloSessao && `seção ${this.state.tituloSessao}`,
                            ].filter(Boolean).join(' · ')
                          : '—'
                      }
                    />
                    <FieldRow label="RG" value={this.state.rg || '—'} />
                    <FieldRow label="Cidade Nasc." value={this.state.cidadeNascimento || '—'} />
                    <FieldRow label="Data Nascimento" value={this.state.dataNascimento || '—'} />
                    <FieldRow label="CNH Número" value={this.state.cnhNumero || '—'} />
                    <FieldRow
                      label="CNH Categoria"
                      value={
                        Array.isArray(this.state.cnhCategoria) && this.state.cnhCategoria.length > 0
                          ? this.state.cnhCategoria.join(', ')
                          : '—'
                      }
                    />
                    <FieldRow label="CNH Data Emissão" value={this.state.cnhDtEmissao || '—'} />
                    <FieldRow label="CNH Data Vencimento" value={this.state.cnhDtVencimento || '—'} />
                    <FieldRow
                      label="Pessoa com deficiência"
                      value={
                        this.state.pcd
                          ? 'Sim — ' +
                            (rotuloTipoPcd(this.state.pcdTipo) || 'tipo não informado') +
                            (this.state.pcdDescricao ? ` (${this.state.pcdDescricao})` : '')
                          : 'Não'
                      }
                    />
                  </div>
                ) : (
                <React.Fragment>
                <Grid container spacing={16}>
                  <Grid item md={6}><TextField fullWidth label={'Nome Mãe'} name={'nomeMae'} value={this.state.nomeMae} onChange={this.handleChange} /></Grid>
                  <Grid item md={6}><TextField fullWidth label={'Nome Pai'} name={'nomePai'} value={this.state.nomePai} onChange={this.handleChange} /></Grid>
                </Grid>
                
                <Grid container spacing={16}>
                  <Grid item md={4}>
                    <FormControl fullWidth={true}>
                    <InputLabel>Estado Civil</InputLabel>
                      <Select value={this.state.estadoCivil} onChange={this.handleChange} inputProps={{ name: 'estadoCivil' }}>
                        <MenuItem value="Solteiro(a)">Solteiro(a)</MenuItem>
                        <MenuItem value="Casado(a)">Casado(a)</MenuItem>
                        <MenuItem value="Divorciado(a)">Divorciado(a)</MenuItem>
                        <MenuItem value="Viúvo(a)">Viúvo(a)</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item md={4}><TextField fullWidth label={'Nacionalidade'} name={'nacionalidade'} value={this.state.nacionalidade} onChange={this.handleChange} /></Grid>
                  <Grid item md={4}><TextField fullWidth label={'PIS'} name={'pisNumero'} value={this.state.pisNumero} onChange={this.handleChange} InputProps={{ inputComponent: ElevenDigitsMaskCustom }}/></Grid>
                </Grid>

                <Grid item md={16}><TextField fullWidth label={'RG'} name={'rg'} value={this.state.rg} onChange={this.handleChange} InputProps={{ inputComponent: RGMaskCustom }}/></Grid>

                <Grid container spacing={16}>
                  <Grid item md={6}><TextField fullWidth label={'Título de Eleitor'} name={'tituloEleitor'} value={this.state.tituloEleitor} onChange={this.handleChange} inputProps={{ maxLength: 64 }} /></Grid>
                  <Grid item md={3}><TextField fullWidth label={'Zona'} name={'tituloZona'} value={this.state.tituloZona} onChange={this.handleChange} inputProps={{ maxLength: 32 }} /></Grid>
                  <Grid item md={3}><TextField fullWidth label={'Seção'} name={'tituloSessao'} value={this.state.tituloSessao} onChange={this.handleChange} inputProps={{ maxLength: 32 }} /></Grid>
                </Grid>

                <Grid container spacing={16}>
                  <Grid item md={6}><TextField fullWidth label={'Cidade Nasc.'} name={'cidadeNascimento'} value={this.state.cidadeNascimento} onChange={this.handleChange} /></Grid>
                  <Grid item md={6}><TextField fullWidth label={'Data Nascimento'} name={'dataNascimento'} value={this.state.dataNascimento} onChange={this.handleChange} InputProps={{ inputComponent: DateMaskCustom }} /></Grid>
                </Grid>

                <Grid container spacing={16}>
                  <Grid item md={6}><TextField fullWidth label={'CNH Número'} name={'cnhNumero'} value={this.state.cnhNumero} onChange={this.handleChange} InputProps={{ inputComponent: NineDigitsMaskCustom }}/></Grid>
                  <Grid item md={6}>
                    <FormControl fullWidth={true}>
                      <InputLabel htmlFor="cnhCategoria">CNH Categoria</InputLabel>
                      <Select multiple value={this.state.cnhCategoria} inputProps={{ name: 'cnhCategoria' }} onChange={this.handleChange} renderValue={(selected) => selected.join(', ')}>
                        <MenuItem value="A">A</MenuItem>
                        <MenuItem value="B">B</MenuItem>
                        <MenuItem value="C">C</MenuItem>
                        <MenuItem value="D">D</MenuItem>
                        <MenuItem value="E">E</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>

                <Grid container spacing={16}>
                  <Grid item md={6}><TextField fullWidth label={'CNH Data Emissão'} name={'cnhDtEmissao'} value={this.state.cnhDtEmissao} onChange={this.handleChange} InputProps={{ inputComponent: DateMaskCustom }} /></Grid>
                  <Grid item md={6}><TextField fullWidth label={'CNH Data Vencimento'} name={'cnhDtVencimento'} value={this.state.cnhDtVencimento} onChange={this.handleChange} InputProps={{ inputComponent: DateMaskCustom }} /></Grid>
                </Grid>

                {/* Deficiência: o tipo (eSocial, para a cota de PcD) num
                    select e o detalhe em texto livre. */}
                <FormControlLabel
                  style={{ marginTop: 16 }}
                  control={
                    <Checkbox
                      color="primary"
                      checked={this.state.pcd}
                      onChange={this.checkHandleChange('pcd')}
                    />
                  }
                  label="Pessoa com deficiência"
                />
                {this.state.pcd && (
                  <Grid container spacing={16}>
                    <Grid item md={5} xs={12}>
                      <FormControl fullWidth={true}>
                        <InputLabel htmlFor="pcdTipo">Tipo de deficiência</InputLabel>
                        <Select value={this.state.pcdTipo} inputProps={{ name: 'pcdTipo' }} onChange={this.handleChange}>
                          {TIPOS_PCD.map(([tipo, rotuloTipo]) => (
                            <MenuItem key={tipo} value={tipo}>{rotuloTipo}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item md={7} xs={12}>
                      <TextField
                        fullWidth
                        label={'Descrição (opcional)'}
                        name={'pcdDescricao'}
                        value={this.state.pcdDescricao}
                        onChange={this.handleChange}
                        inputProps={{ maxLength: 255 }}
                        placeholder={'Ex.: baixa visão no olho esquerdo, usa cadeira de rodas'}
                      />
                    </Grid>
                  </Grid>
                )}

                </React.Fragment>
                )}
                </SecaoFicha>
              </Grid>

              {(() => {
                const documentosContent = (
                  <React.Fragment>
                    <label htmlFor="outlined-contrato-file" style={{ width: '100%', marginTop: '8px' }}>
                      <input id="outlined-contrato-file" type="file" style={{ display: 'none' }} ref={this.documentoInput} onChange={this.handleDocumentacaoFile} multiple />
                      <DsButton intent="secondary" component="span" fullWidth={true}>Anexar Documentação</DsButton>
                    </label>
                    {this.state.documentacao.map((item, index) => {
                        const fileName = item.name && item.name.trim() !== '' ? item.name : `Documento Anexado ${index + 1}`;
                        const fileUrl = item.preview || Utils.normalizeFileUrl(item.link);

                        return (
                            <Chip
                                key={index}
                                label={fileName}
                                onClick={() => window.open(fileUrl, "_blank")}
                                onDelete={() => this.deleteDocumentacaoChip(index)}
                                color="primary"
                                variant="outlined"
                                style={{
                                    marginTop: '8px',
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    cursor: 'pointer'
                                }}
                            />
                        );
                    })}
                  </React.Fragment>
                );

                const sistemaContent = (
                  <TextField fullWidth label={'Projeto Atual'} value={this.state.projetoAtualNome || '—'} disabled={true} style={{ cursor: 'not-allowed' }} />
                );

                // Perfil de acesso e projeto: só no cadastro novo. Na ficha
                // eles mudam em Sistema › Usuários.
                const acessoContent = (
                  <React.Fragment>
                    <FormControl fullWidth={true}>
                      <InputLabel htmlFor="profile">Perfil</InputLabel>
                      <Select value={this.state.perfil} inputProps={{ name: 'perfil' }} error={this.state.perfilErro} onChange={this.handleChange}>
                        {this.state.perfilList.map((item) => <MenuItem key={item.id_perfil} value={item.id_perfil}>{item.desc_perfil}</MenuItem>)}
                      </Select>
                    </FormControl>
                    <FormControl component="fieldset" style={{ marginTop: '16px' }}>
                      <FormLabel>Funcionario exclusivo de um projeto?</FormLabel>
                      <RadioGroup name="exclusivo" row={true} value={this.state.exclusivo} onChange={this.exclusivoHandleChange}>
                        <FormControlLabel value={'true'} control={<Radio color={'primary'} />} label="Sim" />
                        <FormControlLabel value={'false'} control={<Radio color={'primary'} />} label="Não" />
                      </RadioGroup>
                    </FormControl>
                    {this.state.exclusivo == 'true' && (
                      <FormControl fullWidth={true}>
                        <InputLabel htmlFor="projetos">Selecione o Projeto</InputLabel>
                        <Select error={this.state.projectErro} value={this.state.project} inputProps={{ name: 'project' }} onChange={this.handleChange}>
                          {this.state.projectList.map((item) => <MenuItem key={item.id_projeto} value={item.id_projeto}>{item.display}</MenuItem>)}
                        </Select>
                      </FormControl>
                    )}
                  </React.Fragment>
                );

                if (pageMode) {
                  return (
                    <React.Fragment>
                      <Grid item md={6} style={{ width: '100%' }}>
                        <Panel title="Documentos">{documentosContent}</Panel>
                      </Grid>
                      <Grid item md={6} style={{ width: '100%' }}>
                        {novo ? (
                          <Panel title="Acesso e projeto">{acessoContent}</Panel>
                        ) : (
                          <Panel title="Informações Sistema">{sistemaContent}</Panel>
                        )}
                      </Grid>
                    </React.Fragment>
                  );
                }

                return (
                  <Grid item md={4} style={{ width: '100%' }}>
                    {!this.state.edicao && (
                      <React.Fragment>
                        <FormControl fullWidth={true}>
                          <InputLabel htmlFor="profile">Perfil</InputLabel>
                          <Select value={this.state.perfil} inputProps={{ name: 'perfil' }} error={this.state.perfilErro} onChange={this.handleChange}>
                            {this.state.perfilList.map((item) => <MenuItem key={item.id_perfil} value={item.id_perfil}>{item.desc_perfil}</MenuItem>)}
                          </Select>
                        </FormControl>
                        <FormControl component="fieldset" style={{ marginTop: '16px' }}>
                          <FormLabel>Funcionario exclusivo de um projeto?</FormLabel>
                          <RadioGroup name="exclusivo" row={true} value={this.state.exclusivo} onChange={this.exclusivoHandleChange}>
                            <FormControlLabel value={'true'} control={<Radio color={'primary'} />} label="Sim" />
                            <FormControlLabel value={'false'} control={<Radio color={'primary'} />} label="Não" />
                          </RadioGroup>
                        </FormControl>
                      </React.Fragment>
                    )}

                    {this.state.exclusivo == 'true' && (
                      <FormControl fullWidth={true}>
                        <InputLabel htmlFor="projetos">Selecione o Projeto</InputLabel>
                        <Select error={this.state.projectErro} value={this.state.project} inputProps={{ name: 'project' }} onChange={this.handleChange}>
                          {this.state.projectList.map((item) => <MenuItem key={item.id_projeto} value={item.id_projeto}>{item.display}</MenuItem>)}
                        </Select>
                      </FormControl>
                    )}

                    <InputLabel style={{ fontSize: '18px', display: 'block', marginTop: '8px' }}>Documentos</InputLabel>
                    {documentosContent}
                    <SectionTitle style={{ marginTop: '20px' }}>Informações Sistema</SectionTitle>
                    {sistemaContent}
                  </Grid>
                );
              })()}
            </Grid>

            <Grid container spacing={40} style={pageMode ? { marginTop: 24 } : undefined}>
              <Grid item md={pageMode ? 6 : 4} style={{ width: '100%' }}>
              <SecaoFicha pageMode={pageMode} title="Endereço" actions={acoesSecao('endereco')}>
              {leitura('endereco') ? (
                <div>
                  <FieldRow label="CEP Residencial" value={this.state.cep || '—'} />
                  <FieldRow label="Endereço" value={this.state.endereco || '—'} />
                  <FieldRow label="Número" value={this.state.numeroEndereco || '—'} />
                  <FieldRow label="Complemento" value={this.state.complemento || '—'} />
                  <FieldRow label="Bairro" value={this.state.bairro || '—'} />
                  <FieldRow label="Cidade" value={this.state.cidade || '—'} />
                  <FieldRow label="UF" value={this.state.uf || '—'} />
                </div>
              ) : (
              <React.Fragment>

              <FormControl fullWidth={true}>
                <TextField label={'CEP Residêncial'} name={'cep'} value={this.state.cep} onChange={this.CEPhandleChange} InputProps={{ inputComponent: CEPMaskCustom }} error={this.state.cepErro} />
              </FormControl>

              <FormControl fullWidth={true}>
                <TextField label={'Endereço'} name={'endereco'} value={this.state.endereco} onChange={this.handleChange} error={this.state.enderecoErro} />
              </FormControl>

              <Grid container spacing={16}>
                <Grid item md={6} style={styles.halfGrid}>
                  <FormControl fullWidth={true}>
                    <TextField label={'Número'} name={'numeroEndereco'} value={this.state.numeroEndereco} onChange={this.handleChange} error={this.state.numeroEnderecoErro} />
                  </FormControl>

                  <FormControl fullWidth={true}>
                    <TextField label={'Complemento'} name={'complemento'} value={this.state.complemento} onChange={this.handleChange} />
                  </FormControl>

                </Grid>
              </Grid>

              <FormControl fullWidth={true}>
                <TextField label={'Bairro'} name={'bairro'} value={this.state.bairro} onChange={this.handleChange} error={this.state.bairroErro} />
              </FormControl>

              <Grid container spacing={8}>
                <Grid item md={6} style={styles.halfGrid}>
                  <FormControl fullWidth={true}>
                    <TextField label={'Cidade'} name={'cidade'} value={this.state.cidade} onChange={this.handleChange} error={this.state.cidadeErro} />
                  </FormControl>

                  <FormControl fullWidth={true}>
                    <TextField label={'UF'} name={'uf'} value={this.state.uf} onChange={this.handleChange} error={this.state.ufErro} />
                  </FormControl>
                </Grid>
              </Grid>
              </React.Fragment>
              )}
              </SecaoFicha>
            </Grid>

              <Grid item md={pageMode ? 6 : 4} style={{ width: '100%' }}>
                <SecaoFicha pageMode={pageMode} title="Contato" actions={acoesSecao('contato')}>
                {leitura('contato') ? (
                  <div>
                    <FieldRow label="E-mail Pessoal" value={this.state.emailPessoal || '—'} />
                    <FieldRow label="Celular" value={this.state.celular || '—'} />
                    <FieldRow label="Telefone Ambiental" value={this.state.telefone || '—'} />
                  </div>
                ) : (
                <React.Fragment>
                <FormControl fullWidth={true}>
                  <TextField type="email" label={'E-mail Pessoal'} name={'emailPessoal'} value={this.state.emailPessoal} onChange={this.handleChange} error={this.state.emailPessoalErro} />
                </FormControl>

                <Grid container spacing={16}>
                  <Grid item md={6} style={styles.halfGrid}>
                    <FormControl fullWidth={true}>
                      <TextField label={'Celular'} name={'celular'} value={this.state.celular} onChange={this.handleChange} InputProps={{ inputComponent: CelMaskCustom }} />
                    </FormControl>

                    <FormControl fullWidth={true}>
                      <TextField label={'Telefone Ambiental'} name={'telefone'} value={this.state.telefone} onChange={this.handleChange} InputProps={{ inputComponent: TelMaskCustom }} error={this.state.telefoneErro} />
                    </FormControl>

                  </Grid>
                </Grid>
                </React.Fragment>
                )}
              </SecaoFicha>

            </Grid>
            </Grid>



            {(!pageMode || novo) && (
              <Grid style={{ marginTop: '2em' }} container={true} direction="row" justify="center" alignItems="center">
                <DsButton intent="primary" onClick={this.validaForm}>Salvar</DsButton>
              </Grid>
            )}
          <Modal
            title="Histórico de salário"
            isOpen={this.state.histSalarioAberto}
            onClose={this.fecharHistoricoSalario}
            maxWidth="md"
            fullWidth
          >
            <div style={{ marginTop: 16 }}>
              {this.state.histSalarioCarregando ? (
                <p style={{ color: '#666' }}>Carregando histórico...</p>
              ) : (
                <React.Fragment>
                  {this.renderSolicitacoesSalario()}

                  {this.state.histSalarioLista.length === 0 ? (
                    <div style={{ padding: '8px 0 16px' }}>
                      <p style={{ color: '#666', margin: '0 0 12px' }}>
                        Nenhum salário registrado ainda. Quando a primeira mudança for aprovada,
                        o salário que está hoje na ficha é guardado automaticamente no histórico,
                        valendo da data de admissão até a véspera do novo.
                      </p>
                    </div>
                  ) : (
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>Salário</TableCell>
                          <TableCell>Ajuda de custo</TableCell>
                          <TableCell>Complemento</TableCell>
                          <TableCell>A partir de</TableCell>
                          <TableCell>Até</TableCell>
                          <TableCell>Motivo</TableCell>
                          <TableCell>Aprovado por</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {this.state.histSalarioLista.map((item) => (
                          <TableRow key={item.id}>
                            <TableCell>{'R$ ' + Utils.float2moeda(parseFloat(item.salario))}</TableCell>
                            <TableCell>
                              {item.valor_ajuda_custo != null ? 'R$ ' + Utils.float2moeda(parseFloat(item.valor_ajuda_custo)) : '-'}
                            </TableCell>
                            <TableCell>
                              {item.valor_complemento != null ? 'R$ ' + Utils.float2moeda(parseFloat(item.valor_complemento)) : '-'}
                            </TableCell>
                            <TableCell>{Utils.dateToPT(item.dt_vigencia_inicio)}</TableCell>
                            <TableCell>
                              {item.dt_vigencia_fim ? Utils.dateToPT(item.dt_vigencia_fim) : 'Vigente'}
                            </TableCell>
                            <TableCell>{item.motivo || '-'}</TableCell>
                            <TableCell>
                              {item.aprovado_por_nome || item.aprovado_por ||
                                (item.origem === 'importacao' ? 'Importação' : 'Anterior à aprovação')}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  )}

                  {this.state.histSalarioFormAberto ? (
                    <div style={{ marginTop: 24, borderTop: '1px solid #e0e0e0', paddingTop: 16 }}>
                      <Grid container spacing={16}>
                        <Grid item md={4} xs={12}>
                          <CurrencyInput
                            fullWidth
                            label={'Novo salário'}
                            name={'histSalarioValor'}
                            value={this.state.histSalarioValor}
                            onChange={this.handleHistSalarioChange}
                          />
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <CurrencyInput
                            fullWidth
                            label={'Ajuda de custo'}
                            name={'histSalarioAjuda'}
                            value={this.state.histSalarioAjuda}
                            onChange={this.handleHistSalarioChange}
                          />
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <CurrencyInput
                            fullWidth
                            label={'Complemento'}
                            name={'histSalarioComplemento'}
                            value={this.state.histSalarioComplemento}
                            onChange={this.handleHistSalarioChange}
                          />
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <TextField
                            fullWidth
                            label={'Passa a valer em'}
                            name={'histSalarioData'}
                            value={this.state.histSalarioData}
                            onChange={this.handleHistSalarioChange}
                            InputProps={{ inputComponent: DateMaskCustom }}
                          />
                        </Grid>
                        <Grid item md={8} xs={12}>
                          <TextField
                            fullWidth
                            label={'Motivo'}
                            name={'histSalarioMotivo'}
                            value={this.state.histSalarioMotivo}
                            onChange={this.handleHistSalarioChange}
                            placeholder={'Ex.: reajuste anual, promoção, dissídio'}
                          />
                        </Grid>
                      </Grid>
                      <p style={{ color: '#666', fontSize: 13, margin: '12px 0 0' }}>
                        A mudança só vale depois que um sócio aprovar.
                      </p>
                      <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 16 }}>
                        <DsButton
                          type="button"
                          intent="secondary"
                          onClick={this.fecharFormNovoSalario}
                          disabled={this.state.histSalarioSalvando}
                        >
                          Cancelar
                        </DsButton>
                        <DsButton
                          type="button"
                          intent="primary"
                          onClick={this.salvarNovoSalario}
                          disabled={this.state.histSalarioSalvando}
                        >
                          {this.state.histSalarioSalvando ? 'Enviando...' : 'Enviar para aprovação'}
                        </DsButton>
                      </div>
                    </div>
                  ) : (
                    // Um pedido por vez: com um pendente, o botão some até a
                    // decisão (o servidor também recusa um segundo).
                    !this.state.histSalarioSolicitacoes.some((x) => x.status === 'pendente') && (
                      <div style={{ marginTop: 16 }}>
                        <DsButton
                          type="button"
                          intent="primary"
                          onClick={() => this.abrirFormNovoSalario('')}
                        >
                          Pedir mudança de salário
                        </DsButton>
                      </div>
                    )
                  )}
                </React.Fragment>
              )}
            </div>
          </Modal>

          <Modal
            title="Férias"
            isOpen={this.state.feriasAberto}
            onClose={this.fecharFerias}
            maxWidth="md"
            fullWidth
          >
            <div style={{ marginTop: 16 }}>
              {this.state.feriasCarregando ? (
                <p style={{ color: '#666' }}>Carregando férias...</p>
              ) : (
                <React.Fragment>
                  {this.state.feriasLista.length === 0 ? (
                    <p style={{ color: '#666' }}>
                      Nenhum período de férias registrado para este funcionário.
                    </p>
                  ) : (
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>Período aquisitivo</TableCell>
                          <TableCell>Conceder até</TableCell>
                          <TableCell>Período de gozo</TableCell>
                          <TableCell>Dias gozados</TableCell>
                          <TableCell>Vendidos</TableCell>
                          <TableCell>Saldo de dias</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {this.state.feriasLista.map((item) => (
                          <TableRow key={item.id}>
                            <TableCell>
                              {Utils.dateToPT(item.periodo_aquisitivo_inicio)} a {Utils.dateToPT(item.periodo_aquisitivo_fim)}
                            </TableCell>
                            <TableCell>
                              {item.periodo_concessivo_fim
                                ? Utils.dateToPT(item.periodo_concessivo_fim)
                                : '—'}
                            </TableCell>
                            <TableCell>
                              {item.dt_gozo_inicio
                                ? Utils.dateToPT(item.dt_gozo_inicio) + ' a ' + (item.dt_gozo_fim ? Utils.dateToPT(item.dt_gozo_fim) : '?')
                                : 'Não gozado'}
                            </TableCell>
                            <TableCell>{item.dias_gozados}</TableCell>
                            <TableCell>{item.dias_vendidos || 0}</TableCell>
                            <TableCell>{item.dias_saldo}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  )}

                  {this.state.feriasFormAberto ? (
                    <div style={{ marginTop: 24, borderTop: '1px solid #e0e0e0', paddingTop: 16 }}>
                      <Grid container spacing={16}>
                        <Grid item md={3} xs={6}>
                          <TextField fullWidth label={'Aquisitivo - início'} name={'feriasAquisInicio'} value={this.state.feriasAquisInicio} onChange={this.handleVisaoFuncChange} InputProps={{ inputComponent: DateMaskCustom }} />
                        </Grid>
                        <Grid item md={3} xs={6}>
                          <TextField fullWidth label={'Aquisitivo - fim'} name={'feriasAquisFim'} value={this.state.feriasAquisFim} onChange={this.handleVisaoFuncChange} InputProps={{ inputComponent: DateMaskCustom }} />
                        </Grid>
                        <Grid item md={3} xs={6}>
                          <TextField fullWidth label={'Concessivo - início'} name={'feriasConcInicio'} value={this.state.feriasConcInicio} onChange={this.handleVisaoFuncChange} InputProps={{ inputComponent: DateMaskCustom }} />
                        </Grid>
                        <Grid item md={3} xs={6}>
                          <TextField fullWidth label={'Concessivo - fim'} name={'feriasConcFim'} value={this.state.feriasConcFim} onChange={this.handleVisaoFuncChange} InputProps={{ inputComponent: DateMaskCustom }} />
                        </Grid>
                        <Grid item md={3} xs={6}>
                          <TextField fullWidth label={'Gozo - início (opcional)'} name={'feriasGozoInicio'} value={this.state.feriasGozoInicio} onChange={this.handleVisaoFuncChange} InputProps={{ inputComponent: DateMaskCustom }} />
                        </Grid>
                        <Grid item md={3} xs={6}>
                          <TextField fullWidth label={'Gozo - fim (opcional)'} name={'feriasGozoFim'} value={this.state.feriasGozoFim} onChange={this.handleVisaoFuncChange} InputProps={{ inputComponent: DateMaskCustom }} />
                        </Grid>
                        <Grid item md={3} xs={6}>
                          <TextField fullWidth label={'Dias gozados'} name={'feriasDiasGozados'} value={this.state.feriasDiasGozados} onChange={this.handleVisaoFuncChange} />
                        </Grid>
                        <Grid item md={3} xs={6}>
                          <TextField fullWidth label={'Saldo de dias'} name={'feriasDiasSaldo'} value={this.state.feriasDiasSaldo} onChange={this.handleVisaoFuncChange} />
                        </Grid>
                        <Grid item md={3} xs={6}>
                          <TextField fullWidth label={'Dias vendidos (abono, máx. 10)'} name={'feriasDiasVendidos'} value={this.state.feriasDiasVendidos} onChange={this.handleVisaoFuncChange} />
                        </Grid>
                      </Grid>
                      <p style={{ color: '#666', fontSize: 13, marginTop: 8, marginBottom: 0 }}>
                        O período concessivo são os 12 meses seguintes ao aquisitivo — é o prazo
                        para conceder as férias, e o que permite identificar férias vencidas.
                      </p>
                      <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 16 }}>
                        <DsButton type="button" intent="secondary" onClick={() => this.setState({ feriasFormAberto: false })} disabled={this.state.feriasSalvando}>
                          Cancelar
                        </DsButton>
                        <DsButton type="button" intent="primary" onClick={this.salvarFerias} disabled={this.state.feriasSalvando}>
                          {this.state.feriasSalvando ? 'Salvando...' : 'Salvar'}
                        </DsButton>
                      </div>
                    </div>
                  ) : (
                    <div style={{ marginTop: 16 }}>
                      <DsButton type="button" intent="primary" onClick={this.abrirFormFerias}>
                        Registrar período de férias
                      </DsButton>
                    </div>
                  )}
                </React.Fragment>
              )}
            </div>
          </Modal>

          <Modal
            title="13º salário"
            isOpen={this.state.decTerAberto}
            onClose={this.fecharDecTer}
            maxWidth="md"
            fullWidth
          >
            <div style={{ marginTop: 16 }}>
              <p style={{ color: '#666', fontSize: 13, margin: '0 0 12px' }}>
                Duas origens diferentes: o <strong>adiantamento registrado</strong> é o controle
                preenchido aqui na ficha; o <strong>lançado no financeiro</strong> vem de
                Pagamentos/Recebimentos, na conta 2.1.4.4, pelo CPF desta pessoa. Diferença entre
                as duas colunas é justamente o que vale investigar. O ano do lançamento segue a
                competência informada nele; quando não há competência, vale a data de pagamento.
              </p>

              {this.state.decTerCarregando ? (
                <p style={{ color: '#666' }}>Carregando 13º salário...</p>
              ) : (() => {
                const porAno = {};

                this.state.decTerLista.forEach((r) => {
                  const ano = String(r.ano);
                  porAno[ano] = porAno[ano] || { ano: ano, registro: null, lancamentos: [] };
                  porAno[ano].registro = r;
                });

                this.state.decTerFinanceiro.forEach((l) => {
                  const ano = String(l.ano);
                  porAno[ano] = porAno[ano] || { ano: ano, registro: null, lancamentos: [] };
                  porAno[ano].lancamentos.push(l);
                });

                const linhas = Object.keys(porAno)
                  .map((a) => porAno[a])
                  .sort((x, y) => parseInt(y.ano, 10) - parseInt(x.ano, 10));

                if (linhas.length === 0) {
                  return (
                    <p style={{ color: '#666' }}>
                      Nenhum 13º registrado aqui e nenhum lançamento na conta 2.1.4.4 para o CPF
                      desta pessoa.
                    </p>
                  );
                }

                return (
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Ano</TableCell>
                        <TableCell>Registrado na ficha</TableCell>
                        <TableCell>Lançado no financeiro (2.1.4.4)</TableCell>
                        <TableCell />
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {linhas.map((linha) => {
                        const totalFin = linha.lancamentos.reduce(
                          (soma, l) => soma + parseFloat(l.valor || 0),
                          0
                        );

                        return (
                          <TableRow key={linha.ano}>
                            <TableCell>{linha.ano}</TableCell>
                            <TableCell>
                              {!linha.registro ||
                              (!linha.registro.valor_adiantamento && !linha.registro.valor_rescisorio) ? (
                                'Não registrado'
                              ) : (
                                <div>
                                  {linha.registro.valor_adiantamento && (
                                    <div>
                                      {'Adiantamento: R$ '}
                                      {Utils.float2moeda(parseFloat(linha.registro.valor_adiantamento))}
                                      {linha.registro.dt_pagamento_adiantamento
                                        ? ' em ' + Utils.dateToPT(linha.registro.dt_pagamento_adiantamento)
                                        : ''}
                                    </div>
                                  )}
                                  {linha.registro.valor_rescisorio && (
                                    <div style={{ fontSize: 12, color: '#666', marginTop: 2 }}>
                                      {'Rescisório: R$ '}
                                      {Utils.float2moeda(parseFloat(linha.registro.valor_rescisorio))}
                                      {linha.registro.dt_pagamento_rescisorio
                                        ? ' em ' + Utils.dateToPT(linha.registro.dt_pagamento_rescisorio)
                                        : ''}
                                    </div>
                                  )}
                                </div>
                              )}
                            </TableCell>
                            <TableCell>
                              {linha.lancamentos.length === 0 ? (
                                'Nenhum lançamento'
                              ) : (
                                <div>
                                  <strong>R$ {Utils.float2moeda(totalFin)}</strong>
                                  {linha.lancamentos.map((l) => (
                                    <div
                                      key={l.id_lancamento}
                                      style={{ fontSize: 12, color: '#666', marginTop: 2 }}
                                    >
                                      {Utils.dateToPT(l.dt_competencia || l.dt_pag_recb)}
                                      {' · R$ '}
                                      {Utils.float2moeda(parseFloat(l.valor || 0))}
                                      {l.dt_competencia && l.dt_competencia !== l.dt_pag_recb
                                        ? ' · pago em ' + Utils.dateToPT(l.dt_pag_recb)
                                        : ''}
                                      {l.status ? ' · ' + l.status : ''}
                                      {l.desc_curta ? ' · ' + l.desc_curta : ''}
                                    </div>
                                  ))}
                                </div>
                              )}
                            </TableCell>
                            <TableCell>
                              <DsButton
                                type="button"
                                intent="text"
                                onClick={() => this.abrirFormDecTer(linha.registro, linha.ano)}
                              >
                                {linha.registro ? 'Editar adiantamento' : 'Registrar adiantamento'}
                              </DsButton>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                );
              })()}

              {this.state.decTerFormAberto ? (
                <div style={{ marginTop: 24, borderTop: '1px solid #e0e0e0', paddingTop: 16 }}>
                  <Grid container spacing={16}>
                    <Grid item md={2} xs={4}>
                      <TextField fullWidth label={'Ano'} name={'decTerAno'} value={this.state.decTerAno} onChange={this.handleVisaoFuncChange} />
                    </Grid>
                    <Grid item md={4} xs={8}>
                      <CurrencyInput fullWidth label={'Valor do adiantamento'} name={'decTerValorAdiant'} value={this.state.decTerValorAdiant} onChange={this.handleVisaoFuncChange} />
                    </Grid>
                    <Grid item md={3} xs={6}>
                      <TextField fullWidth label={'Pago em'} name={'decTerDataAdiant'} value={this.state.decTerDataAdiant} onChange={this.handleVisaoFuncChange} InputProps={{ inputComponent: DateMaskCustom }} />
                    </Grid>
                    <Grid item md={4} xs={8}>
                      <CurrencyInput fullWidth label={'13º proporcional rescisório'} name={'decTerValorRescisorio'} value={this.state.decTerValorRescisorio} onChange={this.handleVisaoFuncChange} />
                    </Grid>
                    <Grid item md={3} xs={6}>
                      <TextField fullWidth label={'Pago em'} name={'decTerDataRescisorio'} value={this.state.decTerDataRescisorio} onChange={this.handleVisaoFuncChange} InputProps={{ inputComponent: DateMaskCustom }} />
                    </Grid>
                  </Grid>
                  <p style={{ color: '#666', fontSize: 13, marginTop: 8 }}>
                    Isto grava o controle interno do adiantamento. Não cria lançamento em
                    Pagamentos/Recebimentos — o financeiro continua sendo lançado por lá.
                  </p>
                  <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 8 }}>
                    <DsButton type="button" intent="secondary" onClick={() => this.setState({ decTerFormAberto: false })} disabled={this.state.decTerSalvando}>
                      Cancelar
                    </DsButton>
                    <DsButton type="button" intent="primary" onClick={this.salvarDecTer} disabled={this.state.decTerSalvando}>
                      {this.state.decTerSalvando ? 'Salvando...' : 'Salvar'}
                    </DsButton>
                  </div>
                </div>
              ) : (
                <div style={{ marginTop: 16 }}>
                  <DsButton type="button" intent="primary" onClick={() => this.abrirFormDecTer(null, null)}>
                    Registrar adiantamento do 13º
                  </DsButton>
                </div>
              )}
            </div>
          </Modal>

          <Modal
            title="Detalhes do desligamento"
            isOpen={this.state.desligAberto}
            onClose={this.fecharDesligamento}
            maxWidth="md"
            fullWidth
          >
            <div style={{ marginTop: 16 }}>
              {this.state.desligCarregando ? (
                <p style={{ color: '#666' }}>Carregando dados de desligamento...</p>
              ) : (
                <React.Fragment>
                  {this.state.desligLista.length === 0 ? (
                    <p style={{ color: '#666' }}>
                      Nenhum desligamento registrado para este funcionário.
                    </p>
                  ) : (
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>Data</TableCell>
                          <TableCell>Motivo</TableCell>
                          <TableCell>Aviso prévio</TableCell>
                          <TableCell>Multa de FGTS</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {this.state.desligLista.map((item) => (
                          <TableRow key={item.id}>
                            <TableCell>{Utils.dateToPT(item.dt_desligamento)}</TableCell>
                            <TableCell>{rotuloDe(MOTIVOS_DESLIGAMENTO, item.motivo)}</TableCell>
                            <TableCell>
                              {rotuloDe(AVISOS_PREVIOS, item.tipo_aviso_previo)}
                              {item.dias_aviso_previo !== null && item.dias_aviso_previo !== undefined
                                ? ' · ' + item.dias_aviso_previo + ' dia(s)'
                                : ''}
                            </TableCell>
                            <TableCell>
                              {item.multa_fgts_percentual !== null && item.multa_fgts_percentual !== undefined
                                ? parseFloat(item.multa_fgts_percentual) + '%'
                                : simNao(item.multa_fgts_devida)}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  )}

                  {this.state.desligFormAberto ? (
                    <div style={{ marginTop: 24, borderTop: '1px solid #e0e0e0', paddingTop: 16 }}>
                      <Grid container spacing={16}>
                        <Grid item md={3} xs={12}>
                          <TextField fullWidth label={'Data do desligamento'} name={'desligData'} value={this.state.desligData} onChange={this.handleVisaoFuncChange} InputProps={{ inputComponent: DateMaskCustom }} />
                        </Grid>
                        <Grid item md={5} xs={12}>
                          <FormControl fullWidth>
                            <InputLabel htmlFor="desligMotivo">Motivo</InputLabel>
                            <Select
                              value={this.state.desligMotivo}
                              inputProps={{ name: 'desligMotivo', id: 'desligMotivo' }}
                              onChange={this.handleDesligMotivoChange}
                            >
                              {MOTIVOS_DESLIGAMENTO.map((m) => (
                                <MenuItem key={m.valor} value={m.valor}>{m.rotulo}</MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <FormControl fullWidth>
                            <InputLabel htmlFor="desligAviso">Aviso prévio</InputLabel>
                            <Select
                              value={this.state.desligAviso}
                              inputProps={{ name: 'desligAviso', id: 'desligAviso' }}
                              onChange={this.handleDesligAvisoChange}
                            >
                              <MenuItem value="">Não se aplica</MenuItem>
                              {AVISOS_PREVIOS.map((a) => (
                                <MenuItem key={a.valor} value={a.valor}>{a.rotulo}</MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>

                      <Grid container spacing={16} style={{ marginTop: 4 }}>
                        <Grid item md={2} xs={6}>
                          <TextField fullWidth label={'Dias de aviso'} name={'desligDiasAviso'} value={this.state.desligDiasAviso} onChange={this.handleVisaoFuncChange} disabled={this.state.desligAviso === ''} />
                        </Grid>
                        <Grid item md={3} xs={6}>
                          <TextField fullWidth label={'Início do aviso'} name={'desligDtAvisoInicio'} value={this.state.desligDtAvisoInicio} onChange={this.handleVisaoFuncChange} disabled={this.state.desligAviso === ''} InputProps={{ inputComponent: DateMaskCustom }} />
                        </Grid>
                        <Grid item md={3} xs={6}>
                          <TextField fullWidth label={'Fim do aviso'} name={'desligDtAvisoFim'} value={this.state.desligDtAvisoFim} onChange={this.handleVisaoFuncChange} disabled={this.state.desligAviso === ''} InputProps={{ inputComponent: DateMaskCustom }} />
                        </Grid>
                        <Grid item md={2} xs={6}>
                          <TextField fullWidth label={'Multa FGTS (%)'} name={'desligMultaPercentual'} value={this.state.desligMultaPercentual} onChange={this.handleVisaoFuncChange} />
                        </Grid>
                      </Grid>

                      <p style={{ color: '#666', fontSize: 13, marginTop: 8, marginBottom: 0 }}>
                        Os dias de aviso e o percentual da multa são sugeridos pelo motivo e pelo
                        tempo de casa (30 dias mais 3 por ano completo, até 90). Confira e corrija
                        se o caso for diferente.
                      </p>
                      <p style={{ color: '#666', fontSize: 13, marginTop: 8 }}>
                        Ao salvar, a data de desligamento também é preenchida na ficha e o funcionário passa a aparecer como desligado.
                      </p>
                      <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 8 }}>
                        <DsButton type="button" intent="secondary" onClick={() => this.setState({ desligFormAberto: false })} disabled={this.state.desligSalvando}>
                          Cancelar
                        </DsButton>
                        <DsButton type="button" intent="primary" onClick={this.salvarDesligamento} disabled={this.state.desligSalvando}>
                          {this.state.desligSalvando ? 'Salvando...' : 'Salvar'}
                        </DsButton>
                      </div>
                    </div>
                  ) : (
                    <div style={{ marginTop: 16 }}>
                      <DsButton type="button" intent="primary" onClick={this.abrirFormDesligamento}>
                        Registrar desligamento
                      </DsButton>
                    </div>
                  )}
                </React.Fragment>
              )}
            </div>
          </Modal>
          </form>
    );

    if (pageMode) {
      return formContent;
    }

    return (
      <Dialog
        open={this.props.open}
        onClose={this.closeDialog}
        fullWidth
        maxWidth="lg"
        disableBackdropClick={true}
        fullScreen
      >
        <DialogContent>{formContent}</DialogContent>
      </Dialog>
    );
  }
}

export default Form;








